export const airlinesnames = [
  { AirlineName: "AirAsia", AirlineCode: "I5" },
  { AirlineName: "Vistara", AirlineCode: "UK" },
  { AirlineName: "GoFirst", AirlineCode: "G8" },
  { AirlineName: "Air India", AirlineCode: "AI" },
  { AirlineName: "Air India Express", AirlineCode: "IX" },
  { AirlineName: "Star Air", AirlineCode: "OG" },
  { AirlineName: "Emirates Airlines", AirlineCode: "EK" },
  { AirlineName: "IndiGo", AirlineCode: "6E" },
  { AirlineName: "SpiceJet", AirlineCode: "SG" },
  { AirlineName: "Blue Air Transport Aerian", AirlineCode: "0B" },
  { AirlineName: "Darwin Airline", AirlineCode: "0D" },
  { AirlineName: "VIETNAM AIR SERVICE", AirlineCode: "0V" },
  { AirlineName: "BH Air", AirlineCode: "1B" },
  { AirlineName: "Branson Air Express", AirlineCode: "1X" },
  { AirlineName: "DEUTSCHE BAHN AG", AirlineCode: "2A" },
  { AirlineName: "Aerocondor", AirlineCode: "2B" },
  { AirlineName: "SNCF", AirlineCode: "2C" },
  { AirlineName: "Dynamic Airways", AirlineCode: "2D" },
  { AirlineName: "Smokey Bay Air", AirlineCode: "2E" },
  { AirlineName: "Frontier Flying Service", AirlineCode: "2F" },
  { AirlineName: "European Airlines", AirlineCode: "2H" },
  { AirlineName: "Star Peru", AirlineCode: "2I" },
  { AirlineName: "Air Burkina", AirlineCode: "2J" },
  { AirlineName: "AEROGAL", AirlineCode: "2K" },
  { AirlineName: "Helvetic Airways", AirlineCode: "2L" },
  { AirlineName: "Moldavian Airlines", AirlineCode: "2M" },
  { AirlineName: "Next Jet", AirlineCode: "2N" },
  { AirlineName: "Air Philippines", AirlineCode: "2P" },
  { AirlineName: "VIA Rail", AirlineCode: "2R" },
  { AirlineName: "Air Carnival", AirlineCode: "2S" },
  { AirlineName: "Turbo Megha Airways Private Limited", AirlineCode: "2T" },
  { AirlineName: "AMTRAK", AirlineCode: "2V" },
  { AirlineName: "Welcome Air", AirlineCode: "2W" },
  { AirlineName: "Air Andaman", AirlineCode: "2Y" },
  { AirlineName: "Passaredo Airlines", AirlineCode: "2Z" },
  { AirlineName: "Job Air", AirlineCode: "3B" },
  { AirlineName: "Corporate Express Airlines", AirlineCode: "3C" },
  { AirlineName: "Denim Air", AirlineCode: "3D" },
  { AirlineName: "Air Choice One", AirlineCode: "3E" },
  { AirlineName: "Pacific Airways", AirlineCode: "3F" },
  { AirlineName: "Atlant-Soyuz", AirlineCode: "3G" },
  { AirlineName: "Air Inuit", AirlineCode: "3H" },
  { AirlineName: "JUBBA AIRWAYS", AirlineCode: "3J" },
  { AirlineName: "JetStar Asia Airways", AirlineCode: "3K" },
  { AirlineName: "Intersky", AirlineCode: "3L" },
  { AirlineName: "Silver Airways", AirlineCode: "3M" },
  { AirlineName: "Air Urga", AirlineCode: "3N" },
  { AirlineName: "AIR ARABIA MAROC", AirlineCode: "3O" },
  { AirlineName: "Tiara Air", AirlineCode: "3P" },
  { AirlineName: "China Yunnan Airlines", AirlineCode: "3Q" },
  { AirlineName: "Avia Air", AirlineCode: "3R" },
  { AirlineName: "Air Antilles", AirlineCode: "3S" },
  { AirlineName: "Turan Air", AirlineCode: "3T" },
  { AirlineName: "Sichuan Airlines", AirlineCode: "3U" },
  { AirlineName: "Wanair", AirlineCode: "3W" },
  { AirlineName: "Japan Air Commuter", AirlineCode: "3X" },
  { AirlineName: "Necon Air", AirlineCode: "3Z" },
  { AirlineName: "Royal Bengal Airline", AirlineCode: "4A" },
  { AirlineName: "Olson Air Service", AirlineCode: "4B" },
  { AirlineName: "Aires S.A.", AirlineCode: "4C" },
  { AirlineName: "Air Sinai", AirlineCode: "4D" },
  { AirlineName: "Tanana Air", AirlineCode: "4E" },
  { AirlineName: "Air City", AirlineCode: "4F" },
  { AirlineName: "Shenzhen Airlines", AirlineCode: "4G" },
  { AirlineName: "Fly", AirlineCode: "4H" },
  { AirlineName: "Somon Air", AirlineCode: "4J" },
  { AirlineName: "Kenn Borek", AirlineCode: "4K" },
  { AirlineName: "EuroLine", AirlineCode: "4L" },
  { AirlineName: "LAN Argentina", AirlineCode: "4M" },
  { AirlineName: "Air North", AirlineCode: "4N" },
  { AirlineName: "Interjet", AirlineCode: "4O" },
  { AirlineName: "Business Aviation", AirlineCode: "4P" },
  { AirlineName: "SAFI AIRWAYS", AirlineCode: "4Q" },
  { AirlineName: "Orient Eagle Airways", AirlineCode: "4R" },
  { AirlineName: "East West Air", AirlineCode: "4S" },
  { AirlineName: "BELAIR AIRLINES", AirlineCode: "4T" },
  { AirlineName: "Germanwings", AirlineCode: "4U" },
  { AirlineName: "Voyageur Airways", AirlineCode: "4V" },
  { AirlineName: "Warbelow Air", AirlineCode: "4W" },
  { AirlineName: "SOUTH AFRICAN AIRLINK", AirlineCode: "4Z" },
  { AirlineName: "Alpine Aviat", AirlineCode: "5A" },
  { AirlineName: "Tie Aviation", AirlineCode: "5B" },
  { AirlineName: "Nature Air", AirlineCode: "5C" },
  { AirlineName: "Aerolitoral S.A. de C.V.", AirlineCode: "5D" },
  { AirlineName: "Base Airlines", AirlineCode: "5E" },
  { AirlineName: "FLY ONE", AirlineCode: "5f" },
  { AirlineName: "Fly540", AirlineCode: "5H" },
  { AirlineName: "Cebu Pacific", AirlineCode: "5J" },
  { AirlineName: "Odessa Airlines", AirlineCode: "5K" },
  { AirlineName: "Aerosur", AirlineCode: "5L" },
  { AirlineName: "Sibaviatrans", AirlineCode: "5M" },
  { AirlineName: "Nordavia - Regional Airlines", AirlineCode: "5N" },
  { AirlineName: "ASL Airlines France", AirlineCode: "5O" },
  { AirlineName: "Penta Aerial Transports S/A", AirlineCode: "5P" },
  { AirlineName: "BQB Líneas Aéreas", AirlineCode: "5Q" },
  { AirlineName: "IRS Aero", AirlineCode: "5R" },
  { AirlineName: "Canadian North", AirlineCode: "5T" },
  { AirlineName: "TAG - Transportes Aereos Guatemaltecos", AirlineCode: "5U" },
  { AirlineName: "Lviv Airlines", AirlineCode: "5V" },
  { AirlineName: "speed-alliance", AirlineCode: "5W" },
  { AirlineName: "Isles Scilly", AirlineCode: "5Y" },
  { AirlineName: "Aviacsa-Consorcio Aviaxsa", AirlineCode: "6A" },
  { AirlineName: "Air Timor", AirlineCode: "6C" },
  { AirlineName: "Air Wales", AirlineCode: "6G" },
  { AirlineName: "Israir", AirlineCode: "6H" },
  { AirlineName: "Skyservice Airlinesd/b/a Roots Air", AirlineCode: "6J" },
  { AirlineName: "Asian Spirit", AirlineCode: "6K" },
  { AirlineName: "Aklak Air", AirlineCode: "6L" },
  { AirlineName: "Trans Travel Airlines", AirlineCode: "6N" },
  { AirlineName: "Slovak Airlines", AirlineCode: "6Q" },
  { AirlineName: "Saudi Gulf Airlines", AirlineCode: "6S" },
  { AirlineName: "Air Mandalay", AirlineCode: "6T" },
  { AirlineName: "Air Ukraine", AirlineCode: "6U" },
  { AirlineName: "Lignes Aeriennes Congolaises", AirlineCode: "6V" },
  { AirlineName: "Saratov Airlines", AirlineCode: "6W" },
  { AirlineName: "SMARTLYNX AIRLINES", AirlineCode: "6Y" },
  { AirlineName: "Atlant - Souyuz Air", AirlineCode: "7B" },
  { AirlineName: "JEJU AIR", AirlineCode: "7C" },
  { AirlineName: "Donbass Eastern Ukranian Airlines", AirlineCode: "7D" },
  { AirlineName: "Sylt Air", AirlineCode: "7E" },
  { AirlineName: "Firstair", AirlineCode: "7F" },
  { AirlineName: "Bellair", AirlineCode: "7G" },
  { AirlineName: "Corendon", AirlineCode: "7H" },
  { AirlineName: "Insel Air", AirlineCode: "7I" },
  { AirlineName: "Tajik Air", AirlineCode: "7J" },
  { AirlineName: "Kogalymavia", AirlineCode: "7K" },
  { AirlineName: "Aerocaribbean S. A.", AirlineCode: "7L" },
  { AirlineName: "MAYAir", AirlineCode: "7M" },
  { AirlineName: "PAWA DOMINICANA", AirlineCode: "7N" },
  { AirlineName: "Galaxy Air", AirlineCode: "7O" },
  { AirlineName: "Air Venezuela", AirlineCode: "7Q" },
  { AirlineName: "Rusline", AirlineCode: "7R" },
  { AirlineName: "Arctic Transportation Services", AirlineCode: "7S" },
  { AirlineName: "Trans Cote", AirlineCode: "7T" },
  { AirlineName: "Federal Airlines", AirlineCode: "7V" },
  { AirlineName: "Wind Rose Aviation Company", AirlineCode: "7W" },
  { AirlineName: "European Aie Express", AirlineCode: "7Y" },
  { AirlineName: "L B Limited", AirlineCode: "7Z" },
  { AirlineName: "Arctic Air", AirlineCode: "8A" },
  { AirlineName: "Caribbean Star Airlines", AirlineCode: "8B" },
  { AirlineName: "Shanxi Airlines", AirlineCode: "8C" },
  { AirlineName: "Volare Airlines", AirlineCode: "8D" },
  { AirlineName: "Bering Air", AirlineCode: "8E" },
  { AirlineName: "Fischer Air", AirlineCode: "8F" },
  { AirlineName: "Angel Airlines", AirlineCode: "8G" },
  { AirlineName: "Equaflight", AirlineCode: "8H" },
  { AirlineName: "Insel Air Aruba", AirlineCode: "8I" },
  { AirlineName: "Jet4You", AirlineCode: "8J" },
  { AirlineName: "LUCKY AIR", AirlineCode: "8L" },
  { AirlineName: "Myanmar Airways", AirlineCode: "8M" },
  { AirlineName: "Nordkalottlkyg", AirlineCode: "8N" },
  { AirlineName: "West Coast Air", AirlineCode: "8O" },
  { AirlineName: "Pacific Coastal", AirlineCode: "8P" },
  { AirlineName: "Onur Air", AirlineCode: "8Q" },
  { AirlineName: "SOL Lineas Aereas", AirlineCode: "8R" },
  { AirlineName: "Air Tindi", AirlineCode: "8T" },
  { AirlineName: "Afriqiyah Airways", AirlineCode: "8U" },
  { AirlineName: "Wrightair Svc", AirlineCode: "8V" },
  { AirlineName: "Private Wings", AirlineCode: "8W" },
  { AirlineName: "Laser", AirlineCode: "8Z" },
  { AirlineName: "Visa Airways", AirlineCode: "9A" },
  { AirlineName: "ACCESRAIL", AirlineCode: "9B" },
  { AirlineName: "SPRING AIRLINES", AirlineCode: "9C" },
  { AirlineName: "Toumai Air Tchad", AirlineCode: "9D" },
  { AirlineName: "Express Airlines", AirlineCode: "9E" },
  { AirlineName: "Eurostar", AirlineCode: "9F" },
  { AirlineName: "Galaxy Airways", AirlineCode: "9G" },
  { AirlineName: "DUTCH Antiles Express", AirlineCode: "9H" },
  { AirlineName: "Alliance Air", AirlineCode: "9I" },
  { AirlineName: "Pacific Island Aviation", AirlineCode: "9J" },
  { AirlineName: "Cape Air", AirlineCode: "9K" },
  { AirlineName: "Colgan Air", AirlineCode: "9L" },
  { AirlineName: "Central Mountain Air", AirlineCode: "9M" },
  { AirlineName: "Tropic Air", AirlineCode: "9N" },
  { AirlineName: "Pelangi Airways", AirlineCode: "9P" },
  { AirlineName: "Transwest Air", AirlineCode: "9T" },
  { AirlineName: "Air Moldova", AirlineCode: "9U" },
  { AirlineName: "AVIOR AIRLINES", AirlineCode: "9V" },
  { AirlineName: "Jet Airways", AirlineCode: "9W" },
  { AirlineName: "Air Kazakstan", AirlineCode: "9Y" },
  { AirlineName: "Aegean Airlines", AirlineCode: "A3" },
  { AirlineName: "Aerocon", AirlineCode: "A4" },
  { AirlineName: "HOP!", AirlineCode: "A5" },
  { AirlineName: "Air Alps Aviation", AirlineCode: "A6" },
  { AirlineName: "Air Comet", AirlineCode: "A7" },
  { AirlineName: "Aerolineas Paraguayas", AirlineCode: "A8" },
  { AirlineName: "Georgian Airlines", AirlineCode: "A9" },
  { AirlineName: "American Airlines", AirlineCode: "AA" },
  { AirlineName: "Air Berlin", AirlineCode: "AB" },
  { AirlineName: "Air Canada", AirlineCode: "AC" },
  { AirlineName: "Azul Linhas Airline", AirlineCode: "AD" },
  { AirlineName: "Mandarin Airlines", AirlineCode: "AE" },
  { AirlineName: "Air France", AirlineCode: "AF" },
  { AirlineName: "Air Contractors", AirlineCode: "AG" },
  { AirlineName: "Air Algerie", AirlineCode: "AH" },
  { AirlineName: "AeroContractors", AirlineCode: "AJ" },
  { AirlineName: "Airasia", AirlineCode: "AK" },
  { AirlineName: "Astral Aviation", AirlineCode: "AL" },
  { AirlineName: "Aeromexico Aeronaves De Mexico", AirlineCode: "AM" },
  { AirlineName: "Ansett Australia", AirlineCode: "AN" },
  { AirlineName: "Australian Airlines", AirlineCode: "AO" },
  { AirlineName: "Air One", AirlineCode: "AP" },
  { AirlineName: "Aloha Airline", AirlineCode: "AQ" },
  { AirlineName: "Aerolineas Argentinas", AirlineCode: "AR" },
  { AirlineName: "Alaska Airlines", AirlineCode: "AS" },
  { AirlineName: "Royal Air Maroc", AirlineCode: "AT" },
  { AirlineName: "Austral Lineas Aereas Sa", AirlineCode: "AU" },
  { AirlineName: "AVIANCA", AirlineCode: "AV" },
  { AirlineName: "Africa World Airlines", AirlineCode: "AW" },
  { AirlineName: "American Connection", AirlineCode: "AX" },
  { AirlineName: "Finnair", AirlineCode: "AY" },
  { AirlineName: "Alitalia", AirlineCode: "AZ" },
  { AirlineName: "LA COMPAGNIE", AirlineCode: "B0" },
  { AirlineName: "Belavia", AirlineCode: "B2" },
  { AirlineName: "Bhutan Airlines", AirlineCode: "B3" },
  { AirlineName: "B.A.C.H Flugbetrieb", AirlineCode: "B4" },
  { AirlineName: "East African Safari Air Express", AirlineCode: "B5" },
  { AirlineName: "jetBlue", AirlineCode: "B6" },
  { AirlineName: "Uni Airways", AirlineCode: "B7" },
  { AirlineName: "ERITREAN AIRLINES", AirlineCode: "B8" },
  { AirlineName: "Iran Air Tours", AirlineCode: "B9" },
  { AirlineName: "British Airways", AirlineCode: "BA" },
  { AirlineName: "Seaborne Aviation", AirlineCode: "BB" },
  { AirlineName: "Skymark Airlines", AirlineCode: "BC" },
  { AirlineName: "Flybmi", AirlineCode: "BD" },
  { AirlineName: "Flybe", AirlineCode: "BE" },
  { AirlineName: "Markair", AirlineCode: "BF" },
  { AirlineName: "Biman Bangladesh Airlines", AirlineCode: "BG" },
  { AirlineName: "Hawkair", AirlineCode: "BH" },
  { AirlineName: "Royal Brunei Airlines", AirlineCode: "BI" },
  { AirlineName: "Nouvelair", AirlineCode: "BJ" },
  { AirlineName: "Pacific Airlines", AirlineCode: "BL" },
  { AirlineName: "Aero Traporti", AirlineCode: "BM" },
  { AirlineName: "Bahrain Air", AirlineCode: "BN" },
  { AirlineName: "Bouraq Airlines", AirlineCode: "BO" },
  { AirlineName: "Air Botswana", AirlineCode: "BP" },
  { AirlineName: "Eva Airways", AirlineCode: "BR" },
  { AirlineName: "British Intl", AirlineCode: "BS" },
  { AirlineName: "Air Baltic", AirlineCode: "BT" },
  { AirlineName: "Braathens ASA", AirlineCode: "BU" },
  { AirlineName: "Blue Panorama Airlines", AirlineCode: "BV" },
  { AirlineName: "Caribbean Airlines", AirlineCode: "BW" },
  { AirlineName: "Air Busan", AirlineCode: "BX" },
  { AirlineName: "Thomson Fly", AirlineCode: "BY" },
  { AirlineName: "Keystone Air Service", AirlineCode: "BZ" },
  { AirlineName: "CEIBA INTERCONTINENTAL", AirlineCode: "C2" },
  { AirlineName: "Icar", AirlineCode: "C3" },
  { AirlineName: "CommutAir", AirlineCode: "C5" },
  { AirlineName: "Aerocontinente Chile", AirlineCode: "C7" },
  { AirlineName: "Chicago Express Airlines", AirlineCode: "C8" },
  { AirlineName: "Cirrus Airlines", AirlineCode: "C9" },
  { AirlineName: "Air China", AirlineCode: "CA" },
  { AirlineName: "ScotAirways", AirlineCode: "CB" },
  { AirlineName: "Macair", AirlineCode: "CC" },
  { AirlineName: "Alliance-Air", AirlineCode: "CD" },
  { AirlineName: "Nationwide Air", AirlineCode: "CE" },
  { AirlineName: "City Airline", AirlineCode: "CF" },
  { AirlineName: "Milne Bay Air", AirlineCode: "CG" },
  { AirlineName: "Bemidji Aviation", AirlineCode: "CH" },
  { AirlineName: "China Airline", AirlineCode: "CI" },
  { AirlineName: "China Northern Airlines", AirlineCode: "CJ" },
  { AirlineName: "Andesmar Lineas Aereas S", AirlineCode: "CK" },
  { AirlineName: "Lufthansa Cityline Gmbh", AirlineCode: "CL" },
  { AirlineName: "Copa Airlines", AirlineCode: "CM" },
  { AirlineName: "Islands Nationair", AirlineCode: "CN" },
  { AirlineName: "COBALTAIR", AirlineCode: "CO" },
  { AirlineName: "Canadian Airlines International", AirlineCode: "CP" },
  { AirlineName: "Czec Connect Airlines", AirlineCode: "CQ" },
  { AirlineName: "Continental Micronesia", AirlineCode: "CS" },
  { AirlineName: "ALITALIA CITY LINER SPA", AirlineCode: "CT" },
  { AirlineName: "Consolidada Cubana De Avia", AirlineCode: "CU" },
  { AirlineName: "Air Chathams", AirlineCode: "CV" },
  { AirlineName: "Airline Of Marshall Islands", AirlineCode: "CW" },
  { AirlineName: "Cathay Pacific Airways", AirlineCode: "CX" },
  { AirlineName: "Cyprus Airways", AirlineCode: "CY" },
  { AirlineName: "Chinasouthern", AirlineCode: "CZ" },
  { AirlineName: "Severstal Aircompany", AirlineCode: "D2" },
  { AirlineName: "Daallo Airlines", AirlineCode: "D3" },
  { AirlineName: "Alidaunai", AirlineCode: "D4" },
  { AirlineName: "Inter Aviatn", AirlineCode: "D6" },
  { AirlineName: "AirAsia X", AirlineCode: "D7" },
  { AirlineName: "Djibouti Airlines", AirlineCode: "D8" },
  { AirlineName: "Aeroflot-Don", AirlineCode: "D9" },
  { AirlineName: "Brittany Air International", AirlineCode: "DB" },
  { AirlineName: "BRAATHENS REGIONAL", AirlineCode: "DC" },
  { AirlineName: "Atlantic Coast Jet", AirlineCode: "DD" },
  { AirlineName: "Condor Flugdienst Gmbh", AirlineCode: "DE" },
  { AirlineName: "Aebal", AirlineCode: "DF" },
  { AirlineName: "Tigerair Philippines", AirlineCode: "DG" },
  { AirlineName: "Independence", AirlineCode: "DH" },
  { AirlineName: "Deutsche BA", AirlineCode: "DI" },
  { AirlineName: "Virgin Blue", AirlineCode: "DJ" },
  { AirlineName: "Eastland Air", AirlineCode: "DK" },
  { AirlineName: "Delta Air Lines", AirlineCode: "DL" },
  { AirlineName: "Maersk Air", AirlineCode: "DM" },
  { AirlineName: "Senegal Airlines", AirlineCode: "DN" },
  { AirlineName: "Air Vallee", AirlineCode: "DO" },
  { AirlineName: "Air 2000 Limited", AirlineCode: "DP" },
  { AirlineName: "Coastal Air Transport", AirlineCode: "DQ" },
  { AirlineName: "Airmediterranee", AirlineCode: "DR" },
  { AirlineName: "Taag Linhas Aereas De Angola", AirlineCode: "DT" },
  { AirlineName: "Hemus Air", AirlineCode: "DU" },
  { AirlineName: "JSC Aircompany Scat", AirlineCode: "DV" },
  { AirlineName: "Danish Air Transport", AirlineCode: "DX" },
  { AirlineName: "NORWEGIAN AIR SHUTTLE", AirlineCode: "DY" },
  { AirlineName: "Transcaraibes", AirlineCode: "DZ" },
  { AirlineName: "Kampuchea Airlines", AirlineCode: "E2" },
  { AirlineName: "Domodedovo Airlines", AirlineCode: "E3" },
  { AirlineName: "Aero Asia International", AirlineCode: "E4" },
  { AirlineName: "Samara Airlines", AirlineCode: "E5" },
  { AirlineName: "Aviaexpresscruise Airline", AirlineCode: "E6" },
  { AirlineName: "Equaflight Services", AirlineCode: "E7" },
  { AirlineName: "Alpi Eagles", AirlineCode: "E8" },
  { AirlineName: "EVELOP AIRLINES", AirlineCode: "E9" },
  { AirlineName: "European Regions Airlines", AirlineCode: "EA" },
  { AirlineName: "Heli Inter Riviera", AirlineCode: "EC" },
  { AirlineName: "Ccair", AirlineCode: "ED" },
  { AirlineName: "REGIONAL JET", AirlineCode: "EE" },
  { AirlineName: "Far Eastern Air", AirlineCode: "EF" },
  { AirlineName: "Japan Asia Airways", AirlineCode: "EG" },
  { AirlineName: "ANA WINGS", AirlineCode: "EH" },
  { AirlineName: "Aer Lingus Teoranta Aerlinte Eirean", AirlineCode: "EI" },
  { AirlineName: "New England Airlines", AirlineCode: "EJ" },
  { AirlineName: "Ellinair", AirlineCode: "EL" },
  { AirlineName: "Western Airlines", AirlineCode: "EM" },
  { AirlineName: "Air Dolomiti", AirlineCode: "EN" },
  { AirlineName: "Hewa Bora Airways", AirlineCode: "EO" },
  { AirlineName: "Transportes Aereos Militates ecuador", AirlineCode: "EQ" },
  { AirlineName: "Ethiopian Airlines S C", AirlineCode: "ET" },
  { AirlineName: "Empresa Ecuatoriana De Aviacion Sa", AirlineCode: "EU" },
  { AirlineName: "Atlantic Southeast Airlines", AirlineCode: "EV" },
  { AirlineName: "Eurowings", AirlineCode: "EW" },
  { AirlineName: "Air Santo Domingo", AirlineCode: "EX" },
  { AirlineName: "Etihad Airways", AirlineCode: "EY" },
  { AirlineName: "Sun-Air", AirlineCode: "EZ" },
  { AirlineName: "Safarilink", AirlineCode: "F2" },
  { AirlineName: "Flying Enterprise Ab", AirlineCode: "F3" },
  { AirlineName: "Eureca", AirlineCode: "F4" },
  { AirlineName: "Cosmic Air", AirlineCode: "F5" },
  { AirlineName: "China National Aviation", AirlineCode: "F6" },
  { AirlineName: "Etihad Regional", AirlineCode: "F7" },
  { AirlineName: "FLAIR AIRLINES", AirlineCode: "F8" },
  { AirlineName: "Frontier Airlines", AirlineCode: "F9" },
  { AirlineName: "SAF AIR", AirlineCode: "FA" },
  { AirlineName: "Biulgaria Air", AirlineCode: "FB" },
  { AirlineName: "Templehof Express Airlines", AirlineCode: "FC" },
  { AirlineName: "Cityflyer Exp", AirlineCode: "FD" },
  { AirlineName: "Royal Khmer Airlines", AirlineCode: "FE" },
  { AirlineName: "Bakhtar Afghan Airlines", AirlineCode: "FG" },
  { AirlineName: "Icelandair", AirlineCode: "FI" },
  { AirlineName: "Fiji Airways", AirlineCode: "FJ" },
  { AirlineName: "Keewatin Air", AirlineCode: "FK" },
  { AirlineName: "Airtran Airways", AirlineCode: "FL" },
  { AirlineName: "Shanghai Airlines", AirlineCode: "FM" },
  { AirlineName: "fastjet", AirlineCode: "FN" },
  { AirlineName: "Thomas Cook Belgium Airlines", AirlineCode: "FQ" },
  { AirlineName: "Ryan Air", AirlineCode: "FR" },
  { AirlineName: "Syphax Airlines", AirlineCode: "FS" },
  { AirlineName: "Air Littoral", AirlineCode: "FU" },
  { AirlineName: "ROSSIYA-RUSSIAN AIRLINES", AirlineCode: "FV" },
  { AirlineName: "Fair", AirlineCode: "FW" },
  { AirlineName: "Firefly", AirlineCode: "FY" },
  { AirlineName: "Fly Dubai", AirlineCode: "FZ" },
  { AirlineName: "Avirex Gabon", AirlineCode: "G2" },
  { AirlineName: "GOL Linhas Aereas Inteligentes", AirlineCode: "G3" },
  { AirlineName: "Allegiant Air", AirlineCode: "G4" },
  { AirlineName: "Enkor Airlines", AirlineCode: "G5" },
  { AirlineName: "Guine Bissau Airlines", AirlineCode: "G6" },
  { AirlineName: "Gandalf Airlines", AirlineCode: "G7" },
  { AirlineName: "Air Arabia", AirlineCode: "G9" },
  { AirlineName: "Garuda", AirlineCode: "GA" },
  { AirlineName: "Gambia International Airlines", AirlineCode: "GC" },
  { AirlineName: "Transasia Airways", AirlineCode: "GE" },
  { AirlineName: "Gulf Air", AirlineCode: "GF" },
  { AirlineName: "Air Guyane", AirlineCode: "GG" },
  { AirlineName: "Ghana Airways Corporation", AirlineCode: "GH" },
  { AirlineName: "Eurofly", AirlineCode: "GJ" },
  { AirlineName: "Go One Airways", AirlineCode: "GK" },
  { AirlineName: "Global International Airways Corp", AirlineCode: "GL" },
  { AirlineName: "Air Slovakia Bwj", AirlineCode: "GM" },
  { AirlineName: "Air Gabon", AirlineCode: "GN" },
  { AirlineName: "Go", AirlineCode: "GO" },
  { AirlineName: "APG Airline", AirlineCode: "GP" },
  { AirlineName: "Big Sky Airlines", AirlineCode: "GQ" },
  { AirlineName: "Aurigny Air Services", AirlineCode: "GR" },
  { AirlineName: "Grant", AirlineCode: "GS" },
  { AirlineName: "Gibraltar Airways", AirlineCode: "GT" },
  { AirlineName: "Aviateca S A", AirlineCode: "GU" },
  { AirlineName: "Air Lines Of Kuban", AirlineCode: "GW" },
  { AirlineName: "Pacificair", AirlineCode: "GX" },
  { AirlineName: "Guyana Airways Corporation", AirlineCode: "GY" },
  { AirlineName: "Air Rarotonga", AirlineCode: "GZ" },
  { AirlineName: "Hahn Air Systems", AirlineCode: "H1" },
  { AirlineName: "Sky Airline", AirlineCode: "H2" },
  { AirlineName: "Harbour Air", AirlineCode: "H3" },
  { AirlineName: "Inter Islands Airlines", AirlineCode: "H4" },
  { AirlineName: "Magadan Air", AirlineCode: "H5" },
  { AirlineName: "Hageland", AirlineCode: "H6" },
  { AirlineName: "Eagle Aviation Uganda", AirlineCode: "H7" },
  { AirlineName: "Dalavia-Far East Airways Khabarovsk", AirlineCode: "H8" },
  { AirlineName: "Himalyan Airline", AirlineCode: "H9" },
  { AirlineName: "Hawaiian Airlines", AirlineCode: "HA" },
  { AirlineName: "Homer Air", AirlineCode: "HB" },
  { AirlineName: "Aero-Tropics Air Services", AirlineCode: "HC" },
  { AirlineName: "Hokkaido International Airlines", AirlineCode: "HD" },
  { AirlineName: "Lgw Luftfahrtgesellschaft", AirlineCode: "HE" },
  { AirlineName: "Air Côte d'Ivoire", AirlineCode: "HF" },
  { AirlineName: "Niki", AirlineCode: "HG" },
  { AirlineName: "Islandsflug", AirlineCode: "HH" },
  { AirlineName: "Papillon Air", AirlineCode: "HI" },
  { AirlineName: "Swedeways Air Lines", AirlineCode: "HJ" },
  { AirlineName: "Yangon Airways", AirlineCode: "HK" },
  { AirlineName: "Air Mahe/Inter Island Airways", AirlineCode: "HM" },
  { AirlineName: "Proteus Helicopteres", AirlineCode: "HN" },
  { AirlineName: "Juneyao Airline", AirlineCode: "HO" },
  { AirlineName: "America West", AirlineCode: "HP" },
  { AirlineName: "THOMAS COOK AIRLINES BELGIUM", AirlineCode: "HQ" },
  { AirlineName: "Hahn Air", AirlineCode: "HR" },
  { AirlineName: "Skyways Regional", AirlineCode: "HS" },
  { AirlineName: "Royal Airways", AirlineCode: "HT" },
  { AirlineName: "Hainan Airlines", AirlineCode: "HU" },
  { AirlineName: "Transavia Airlines", AirlineCode: "HV" },
  { AirlineName: "North Wright", AirlineCode: "HW" },
  { AirlineName: "Hong Kong Airlines", AirlineCode: "HX" },
  { AirlineName: "Uzbekistan Airways", AirlineCode: "HY" },
  { AirlineName: "Aurora Airlines", AirlineCode: "HZ" },
  { AirlineName: "IBERIA EXPRESS", AirlineCode: "I2" },
  { AirlineName: "Paramount Airways", AirlineCode: "I7" },
  { AirlineName: "Air-Service", AirlineCode: "I9" },
  { AirlineName: "Iraqi/Airways", AirlineCode: "IA" },
  { AirlineName: "Iberia Airlines", AirlineCode: "IB" },
  { AirlineName: "Indian Airlines", AirlineCode: "IC" },
  { AirlineName: "BATIK AIR INDONESIA", AirlineCode: "ID" },
  { AirlineName: "Solomon Islands Airways", AirlineCode: "IE" },
  { AirlineName: "AIR ITALY", AirlineCode: "IG" },
  { AirlineName: "Falcon Air", AirlineCode: "IH" },
  { AirlineName: "Air Liberte", AirlineCode: "IJ" },
  { AirlineName: "Imair", AirlineCode: "IK" },
  { AirlineName: "Intensive Air", AirlineCode: "IM" },
  { AirlineName: "Mat Macedonia", AirlineCode: "IN" },
  { AirlineName: "Atyrau Airways", AirlineCode: "IP" },
  { AirlineName: "Augsburg Airways", AirlineCode: "IQ" },
  { AirlineName: "Iran National Airlines", AirlineCode: "IR" },
  { AirlineName: "Island Airlines", AirlineCode: "IS" },
  { AirlineName: "Tigerair Taiwan", AirlineCode: "IT" },
  { AirlineName: "Air Lib", AirlineCode: "IW" },
  { AirlineName: "Yemen Airways Corporation", AirlineCode: "IY" },
  { AirlineName: "Arkia Israel Inland Airlines", AirlineCode: "IZ" },
  { AirlineName: "JETLINK EXPRE", AirlineCode: "J0" },
  { AirlineName: "Azerbaijan Airlines", AirlineCode: "J2" },
  { AirlineName: "Northwestern Air Lease", AirlineCode: "J3" },
  { AirlineName: "Buffalo Air", AirlineCode: "J4" },
  { AirlineName: "Alaska Seaplanes", AirlineCode: "J5" },
  { AirlineName: "Larrys Flying", AirlineCode: "J6" },
  { AirlineName: "Centre-Avia Airlines", AirlineCode: "J7" },
  { AirlineName: "Berjaya Air", AirlineCode: "J8" },
  { AirlineName: "Jazera Airways", AirlineCode: "J9" },
  { AirlineName: "BH Airlines", AirlineCode: "JA" },
  { AirlineName: "Helijet International", AirlineCode: "JB" },
  { AirlineName: "JAL Express", AirlineCode: "JC" },
  { AirlineName: "Japan Air Sys", AirlineCode: "JD" },
  { AirlineName: "Mango", AirlineCode: "JE" },
  { AirlineName: "Jet Asia Airways", AirlineCode: "JF" },
  { AirlineName: "Nordeste-Linhas Aereas Regionais Sa", AirlineCode: "JH" },
  { AirlineName: "Midway Airlines", AirlineCode: "JI" },
  { AirlineName: "TAM Linhas Aereas", AirlineCode: "JJ" },
  { AirlineName: "Spanair", AirlineCode: "JK" },
  { AirlineName: "Japan Airlines", AirlineCode: "JL" },
  { AirlineName: "Air Jamaica", AirlineCode: "JM" },
  { AirlineName: "Excel Airways", AirlineCode: "JN" },
  { AirlineName: "JALways", AirlineCode: "JO" },
  { AirlineName: "Adria Airways", AirlineCode: "JP" },
  { AirlineName: "Jetstar", AirlineCode: "JQ" },
  { AirlineName: "Aerocalfornia", AirlineCode: "JR" },
  { AirlineName: "Air Koryo", AirlineCode: "JS" },
  { AirlineName: "LionAir", AirlineCode: "JT" },
  { AirlineName: "Air Serbia", AirlineCode: "JU" },
  { AirlineName: "Bearskin Lake", AirlineCode: "JV" },
  { AirlineName: "Skippers Aviation", AirlineCode: "JW" },
  { AirlineName: "Nice Helicopteres", AirlineCode: "JX" },
  { AirlineName: "INTERCARIBBEAN AIRWAYS", AirlineCode: "JY" },
  { AirlineName: "Skyways Ab", AirlineCode: "JZ" },
  { AirlineName: "Eurolot S.A", AirlineCode: "K2" },
  { AirlineName: "Taquan Air Services", AirlineCode: "K3" },
  { AirlineName: "Kronflyg", AirlineCode: "K4" },
  { AirlineName: "Seaport Airlines", AirlineCode: "K5" },
  { AirlineName: "Cambodia Angkor Air", AirlineCode: "K6" },
  { AirlineName: "Sakha Avia", AirlineCode: "K7" },
  { AirlineName: "Skyward Aviation", AirlineCode: "K9" },
  { AirlineName: "Dragonair", AirlineCode: "KA" },
  { AirlineName: "Druk Air", AirlineCode: "KB" },
  { AirlineName: "Air Astana", AirlineCode: "KC" },
  { AirlineName: "KD Avia", AirlineCode: "KD" },
  { AirlineName: "Korean Air Lines", AirlineCode: "KE" },
  { AirlineName: "Oy Air Botnia", AirlineCode: "KF" },
  { AirlineName: "Siem Reap Airways International", AirlineCode: "KH" },
  { AirlineName: "Time Air", AirlineCode: "KI" },
  { AirlineName: "British Mediterranean", AirlineCode: "KJ" },
  { AirlineName: "Atlasjet Airlines", AirlineCode: "KK" },
  { AirlineName: "Klm Royal Dutch Airlines", AirlineCode: "KL" },
  { AirlineName: "Air Malta", AirlineCode: "KM" },
  { AirlineName: "CHINA UNITED AIRLINES", AirlineCode: "KN" },
  { AirlineName: "Alaska Central Express", AirlineCode: "KO" },
  { AirlineName: "ASKY", AirlineCode: "KP" },
  { AirlineName: "Kenya Airways", AirlineCode: "KQ" },
  { AirlineName: "Air Bishkek", AirlineCode: "KR" },
  { AirlineName: "Penair", AirlineCode: "KS" },
  { AirlineName: "Kuwait Airways Corporation", AirlineCode: "KU" },
  { AirlineName: "Kavminvodyavi", AirlineCode: "KV" },
  { AirlineName: "Air Company KAS", AirlineCode: "KW" },
  { AirlineName: "Cayman Airways", AirlineCode: "KX" },
  { AirlineName: "Air Sao Tome e Principe", AirlineCode: "KY" },
  { AirlineName: "Lynden Air", AirlineCode: "L2" },
  { AirlineName: "Lauda-air S.p.A.", AirlineCode: "L4" },
  { AirlineName: "Lufttransport AS", AirlineCode: "L5" },
  { AirlineName: "Air Maldives", AirlineCode: "L6" },
  { AirlineName: "Laoag International Airlines", AirlineCode: "L7" },
  { AirlineName: "AFRIC AVIATION", AirlineCode: "L8" },
  { AirlineName: "Air Mali S.A.", AirlineCode: "L9" },
  { AirlineName: "Lan-Linea Aerea Nacional-Chile Sa", AirlineCode: "LA" },
  { AirlineName: "Air Costa", AirlineCode: "LB" },
  { AirlineName: "ECAIR Equatorial Congo Airlines", AirlineCode: "LC" },
  { AirlineName: "Linea Turistica Aereotuy", AirlineCode: "LD" },
  { AirlineName: "Helgoland Airlines", AirlineCode: "LE" },
  { AirlineName: "Nordic East", AirlineCode: "LF" },
  { AirlineName: "Luxair", AirlineCode: "LG" },
  { AirlineName: "Lufthansa", AirlineCode: "LH" },
  { AirlineName: "Liat", AirlineCode: "LI" },
  { AirlineName: "Sierra Nation", AirlineCode: "LJ" },
  { AirlineName: "Continent Airlines", AirlineCode: "LK" },
  { AirlineName: "Allegro", AirlineCode: "LL" },
  { AirlineName: "Air ALM", AirlineCode: "LM" },
  { AirlineName: "Libyan Arab Airlines", AirlineCode: "LN" },
  { AirlineName: "Lot-Polish", AirlineCode: "LO" },
  { AirlineName: "LanPeru", AirlineCode: "LP" },
  { AirlineName: "LANMEI AIRLINES", AirlineCode: "LQ" },
  { AirlineName: "Lineas Aereas Costarricenses", AirlineCode: "LR" },
  { AirlineName: "Jet2", AirlineCode: "LS" },
  { AirlineName: "Air Lituanica", AirlineCode: "LT" },
  { AirlineName: "MEGA Maldives Airlines", AirlineCode: "LV" },
  { AirlineName: "Pacific Wings", AirlineCode: "LW" },
  { AirlineName: "Swiss", AirlineCode: "LX" },
  { AirlineName: "El Al Israel Airlines Limited", AirlineCode: "LY" },
  { AirlineName: "Belle Air", AirlineCode: "LZ" },
  { AirlineName: "Air Service", AirlineCode: "M3" },
  { AirlineName: "Avioimpex A.D.P.O.", AirlineCode: "M4" },
  { AirlineName: "Kenmore", AirlineCode: "M5" },
  { AirlineName: "Marsland Aviation", AirlineCode: "M7" },
  { AirlineName: "Motor Sich PISC", AirlineCode: "M9" },
  { AirlineName: "Malev Hungarian Airlines", AirlineCode: "MA" },
  { AirlineName: "Military Air", AirlineCode: "MC" },
  { AirlineName: "Air Madagascar", AirlineCode: "MD" },
  { AirlineName: "Middle East Airlines Airliban", AirlineCode: "ME" },
  { AirlineName: "Xiamen Airlines", AirlineCode: "MF" },
  { AirlineName: "Champion Air", AirlineCode: "MG" },
  { AirlineName: "Malaysia Airlines", AirlineCode: "MH" },
  { AirlineName: "Silkair", AirlineCode: "MI" },
  { AirlineName: "Mihin Lanka", AirlineCode: "MJ" },
  { AirlineName: "Air Mauritius", AirlineCode: "MK" },
  { AirlineName: "AIR MEDITERRANEE", AirlineCode: "ML" },
  { AirlineName: "Medellin", AirlineCode: "MM" },
  { AirlineName: "kulula", AirlineCode: "MN" },
  { AirlineName: "Calm Air Intl", AirlineCode: "MO" },
  { AirlineName: "Martinair", AirlineCode: "MP" },
  { AirlineName: "American Eagle", AirlineCode: "MQ" },
  { AirlineName: "Hunnu Air", AirlineCode: "MR" },
  { AirlineName: "Egyptair", AirlineCode: "MS" },
  { AirlineName: "Fly Thomascook", AirlineCode: "MT" },
  { AirlineName: "China Eastern", AirlineCode: "MU" },
  { AirlineName: "Manus Air", AirlineCode: "MV" },
  { AirlineName: "Mokulele Airlines", AirlineCode: "MW" },
  { AirlineName: "Mexicana", AirlineCode: "MX" },
  { AirlineName: "Maya Island Air", AirlineCode: "MY" },
  { AirlineName: "Merpati Nusantara Dba Air Mali", AirlineCode: "MZ" },
  { AirlineName: "Aerolineas Internacionales", AirlineCode: "N2" },
  { AirlineName: "Aero Continente", AirlineCode: "N6" },
  { AirlineName: "National Airlines", AirlineCode: "N7" },
  { AirlineName: "North Coast Aviation Pty", AirlineCode: "N9" },
  { AirlineName: "Nesma Airlines Company", AirlineCode: "NA" },
  { AirlineName: "Sterling", AirlineCode: "NB" },
  { AirlineName: "National Jet Systems Pty", AirlineCode: "NC" },
  { AirlineName: "Airlink Limited", AirlineCode: "ND" },
  { AirlineName: "Nesma Airlines", AirlineCode: "NE" },
  { AirlineName: "Air Vanuatu", AirlineCode: "NF" },
  { AirlineName: "Lauda Air", AirlineCode: "NG" },
  { AirlineName: "All Nippon Airways Co", AirlineCode: "NH" },
  { AirlineName: "Portugalia", AirlineCode: "NI" },
  { AirlineName: "Vanguard Airlines", AirlineCode: "NJ" },
  { AirlineName: "Spirit Airlines", AirlineCode: "NK" },
  { AirlineName: "Shaheen Air", AirlineCode: "NL" },
  { AirlineName: "Vim Airlines", AirlineCode: "NN" },
  { AirlineName: "NILE AIR", AirlineCode: "NP" },
  { AirlineName: "Air Japan", AirlineCode: "NQ" },
  { AirlineName: "HEBEI AIRLINES", AirlineCode: "NS" },
  { AirlineName: "Binter Canarias", AirlineCode: "NT" },
  { AirlineName: "Japan Transocean Air", AirlineCode: "NU" },
  { AirlineName: "Northwest Territorial Airways", AirlineCode: "NV" },
  { AirlineName: "Northwest Airlines", AirlineCode: "NW" },
  { AirlineName: "Air Macau Company Limited", AirlineCode: "NX" },
  { AirlineName: "Air Iceland", AirlineCode: "NY" },
  { AirlineName: "New Zealand", AirlineCode: "NZ" },
  { AirlineName: "JET AIR", AirlineCode: "O2" },
  { AirlineName: "COMORES AVIATION INTL", AirlineCode: "O5" },
  { AirlineName: "Avianca Brasil", AirlineCode: "O6" },
  { AirlineName: "SIAM AIR TRANSPORT", AirlineCode: "O8" },
  { AirlineName: "Olympic Airways", AirlineCode: "OA" },
  { AirlineName: "Boliviana de Aviación", AirlineCode: "OB" },
  { AirlineName: "Omni", AirlineCode: "OC" },
  { AirlineName: "Malindo Air", AirlineCode: "OD" },
  { AirlineName: "Westair Commuter Airlines", AirlineCode: "OE" },
  { AirlineName: "Comair", AirlineCode: "OH" },
  { AirlineName: "Aspiring Air", AirlineCode: "OI" },
  { AirlineName: "Czech Airline", AirlineCode: "OK" },
  { AirlineName: "Ostfriesische Lufttransport Gmbh", AirlineCode: "OL" },
  { AirlineName: "Miat Mongolia", AirlineCode: "OM" },
  { AirlineName: "Air Nauru", AirlineCode: "ON" },
  { AirlineName: "Skywest Air", AirlineCode: "OO" },
  { AirlineName: "Air Pegsus", AirlineCode: "OP" },
  { AirlineName: "Sunrise Airlines", AirlineCode: "OQ" },
  { AirlineName: "Arkefly", AirlineCode: "OR" },
  { AirlineName: "Austrian Airlines", AirlineCode: "OS" },
  { AirlineName: "Aeropelican Air Services", AirlineCode: "OT" },
  { AirlineName: "Croatia Airlines", AirlineCode: "OU" },
  { AirlineName: "Salam Air", AirlineCode: "OV" },
  { AirlineName: "Executive Airlines/American Eagle", AirlineCode: "OW" },
  { AirlineName: "Orient Thai Airlines", AirlineCode: "OX" },
  { AirlineName: "OMNI AIR INTL", AirlineCode: "OY" },
  { AirlineName: "Asiana Air", AirlineCode: "OZ" },
  { AirlineName: "Proflight Zambia", AirlineCode: "P0" },
  { AirlineName: "TyumenaviaTrans", AirlineCode: "P2" },
  { AirlineName: "Aero Lineas Sosa", AirlineCode: "P4" },
  { AirlineName: "Aerorepublica", AirlineCode: "P5" },
  { AirlineName: "Pascan Aviation", AirlineCode: "P6" },
  { AirlineName: "East Line Airlines", AirlineCode: "P7" },
  { AirlineName: "Pantanal Linhas Aereas Sul", AirlineCode: "P8" },
  { AirlineName: "Peruvian Airlines", AirlineCode: "P9" },
  { AirlineName: "AIRBLUE", AirlineCode: "PA" },
  { AirlineName: "Provincial Airlines", AirlineCode: "PB" },
  { AirlineName: "PEGASUS AIRLINES", AirlineCode: "PC" },
  { AirlineName: "Porter Airlines", AirlineCode: "PD" },
  { AirlineName: "Air Europe", AirlineCode: "PE" },
  { AirlineName: "Palestinian Airlines", AirlineCode: "PF" },
  { AirlineName: "Bangkok Airways", AirlineCode: "PG" },
  { AirlineName: "Polynesian Airlines", AirlineCode: "PH" },
  { AirlineName: "Sol del Paraquay Lineas Aereas", AirlineCode: "PI" },
  { AirlineName: "Air Saint-Pierre", AirlineCode: "PJ" },
  { AirlineName: "Pakistan International Airlines", AirlineCode: "PK" },
  { AirlineName: "Tropic Air", AirlineCode: "PM" },
  { AirlineName: "Pan American Airways Corp.", AirlineCode: "PN" },
  { AirlineName: "AIRASIA PHILIPPINES", AirlineCode: "PQ" },
  { AirlineName: "Philippine Airlines", AirlineCode: "PR" },
  { AirlineName: "Ukraine International Airlines", AirlineCode: "PS" },
  { AirlineName: "West Air Sweden", AirlineCode: "PT" },
  { AirlineName: "Primeras Lineas Uruguayas", AirlineCode: "PU" },
  { AirlineName: "Saint Barth Commuter", AirlineCode: "PV" },
  { AirlineName: "Precisionair", AirlineCode: "PW" },
  { AirlineName: "Air Niugini", AirlineCode: "PX" },
  { AirlineName: "Surinam Airways", AirlineCode: "PY" },
  { AirlineName: "Transportes Aereos Del Mercosur", AirlineCode: "PZ" },
  { AirlineName: "Island Aviation Services", AirlineCode: "Q2" },
  { AirlineName: "Zambian Airways", AirlineCode: "Q3" },
  { AirlineName: "40 Mile Air", AirlineCode: "Q5" },
  { AirlineName: "Sobelair", AirlineCode: "Q7" },
  { AirlineName: "Pacific East Asia Cargo Airlines", AirlineCode: "Q8" },
  { AirlineName: "Air Liaison", AirlineCode: "Q9" },
  { AirlineName: "Aerocaribe", AirlineCode: "QA" },
  { AirlineName: "SkyGeorgia", AirlineCode: "QB" },
  { AirlineName: "Camair-Co", AirlineCode: "QC" },
  { AirlineName: "JC CAMBODIA INTL AIRLINES", AirlineCode: "QD" },
  {
    AirlineName: "Europ Continental Airways d/b/a Crossair Europe",
    AirlineCode: "QE",
  },
  { AirlineName: "Qantas Airways", AirlineCode: "QF" },
  { AirlineName: "Delta Air Transport", AirlineCode: "QG" },
  { AirlineName: "Air Kyrgyzstan", AirlineCode: "QH" },
  { AirlineName: "Cimber Air", AirlineCode: "QI" },
  { AirlineName: "Latpass Airlines", AirlineCode: "QJ" },
  { AirlineName: "Air Nova", AirlineCode: "QK" },
  { AirlineName: "Aero Lanka", AirlineCode: "QL" },
  { AirlineName: "Air Malawi", AirlineCode: "QM" },
  { AirlineName: "Royal Aviation", AirlineCode: "QN" },
  { AirlineName: "Qatar Airways", AirlineCode: "QR" },
  { AirlineName: "Smart Wings", AirlineCode: "QS" },
  { AirlineName: "Regional Air", AirlineCode: "QT" },
  { AirlineName: "Uganda Air", AirlineCode: "QU" },
  { AirlineName: "Lao Aviation", AirlineCode: "QV" },
  { AirlineName: "Turks And Caicos National Airline", AirlineCode: "QW" },
  { AirlineName: "Horizon Airlines", AirlineCode: "QX" },
  { AirlineName: "European Air Transport", AirlineCode: "QY" },
  { AirlineName: "PT Indonesia AirAsia", AirlineCode: "QZ" },
  { AirlineName: "Orenburg", AirlineCode: "R2" },
  { AirlineName: "Aircompany Yakutia", AirlineCode: "R3" },
  { AirlineName: "The State Transport Company Russia", AirlineCode: "R4" },
  { AirlineName: "Malta Air Charter", AirlineCode: "R5" },
  { AirlineName: "Air Srpska", AirlineCode: "R6" },
  { AirlineName: "Aserco Airlines", AirlineCode: "R7" },
  { AirlineName: "Camai Air", AirlineCode: "R9" },
  { AirlineName: "Royal Nepal Airlines Corp", AirlineCode: "RA" },
  { AirlineName: "Syrian Arab Airlines", AirlineCode: "RB" },
  { AirlineName: "Atlantic Airways Faroe Islands", AirlineCode: "RC" },
  { AirlineName: "Alitalia Team", AirlineCode: "RD" },
  { AirlineName: "Aer Arann Express", AirlineCode: "RE" },
  { AirlineName: "Varig", AirlineCode: "RG" },
  { AirlineName: "Regionnair", AirlineCode: "RH" },
  { AirlineName: "P.T.Mandala Airlines", AirlineCode: "RI" },
  { AirlineName: "Royal Jordanian", AirlineCode: "RJ" },
  { AirlineName: "Air Afrique", AirlineCode: "RK" },
  { AirlineName: "Royal Phnom Penh Airways", AirlineCode: "RL" },
  { AirlineName: "Air Moldova I", AirlineCode: "RM" },
  { AirlineName: "Tarom", AirlineCode: "RO" },
  { AirlineName: "Chantangua Airlines", AirlineCode: "RP" },
  { AirlineName: "Kam Air", AirlineCode: "RQ" },
  { AirlineName: "Royal Air Force-38 Transport Group", AirlineCode: "RR" },
  { AirlineName: "S Seoul", AirlineCode: "RS" },
  { AirlineName: "Jsc Uvt Aero", AirlineCode: "RT" },
  { AirlineName: "Tci Skyking", AirlineCode: "RU" },
  { AirlineName: "Caspian Air Lines", AirlineCode: "RV" },
  { AirlineName: "Ras Fluggesellschaft", AirlineCode: "RW" },
  { AirlineName: "Regent Airways", AirlineCode: "RX" },
  { AirlineName: "European Executive Express", AirlineCode: "RY" },
  { AirlineName: "Servicios Aereos Nacionales S A", AirlineCode: "RZ" },
  { AirlineName: "JetKonnect", AirlineCode: "S2" },
  { AirlineName: "Santa Barbara Airlines", AirlineCode: "S3" },
  { AirlineName: "Sata International", AirlineCode: "S4" },
  { AirlineName: "Shuttle America", AirlineCode: "S5" },
  { AirlineName: "Siberia Airlines", AirlineCode: "S7" },
  { AirlineName: "Estonian Aviation Company", AirlineCode: "S8" },
  { AirlineName: "South African Airways", AirlineCode: "SA" },
  { AirlineName: "Air Caledonie International", AirlineCode: "SB" },
  { AirlineName: "Shandong Air", AirlineCode: "SC" },
  { AirlineName: "Sudan Airways", AirlineCode: "SD" },
  { AirlineName: "XL AIRWAYS FRANCE", AirlineCode: "SE" },
  { AirlineName: "Tassili Airlines", AirlineCode: "SF" },
  { AirlineName: "Blue Islands", AirlineCode: "SI" },
  { AirlineName: "Scandinavian Airlines System", AirlineCode: "SK" },
  { AirlineName: "THAI LION MENTARI", AirlineCode: "SL" },
  { AirlineName: "Sunworld Intl", AirlineCode: "SM" },
  { AirlineName: "SN Brussels Airlines", AirlineCode: "SN" },
  { AirlineName: "Sociedade Acoreana De Transportes", AirlineCode: "SP" },
  { AirlineName: "Singapore Airlines", AirlineCode: "SQ" },
  { AirlineName: "Swiss Air Transport Co", AirlineCode: "SR" },
  { AirlineName: "Corsair International", AirlineCode: "SS" },
  { AirlineName: "Germania", AirlineCode: "ST" },
  { AirlineName: "Aeroflot Russian Airlines", AirlineCode: "SU" },
  { AirlineName: "Saudi Arabian Airlines", AirlineCode: "SV" },
  { AirlineName: "Air Namibia", AirlineCode: "SW" },
  { AirlineName: "Sky Work Airlines", AirlineCode: "SX" },
  { AirlineName: "Sun Country Airlines", AirlineCode: "SY" },
  { AirlineName: "Somon Air", AirlineCode: "SZ" },
  { AirlineName: "TACA PERU", AirlineCode: "T0" },
  { AirlineName: "Nakima Air Service", AirlineCode: "T2" },
  { AirlineName: "Eastern Airways", AirlineCode: "T3" },
  { AirlineName: "Hellas Jet", AirlineCode: "T4" },
  { AirlineName: "Turkmenistan", AirlineCode: "T5" },
  { AirlineName: "Tavrey Aircompany", AirlineCode: "T6" },
  { AirlineName: "Twin Jet", AirlineCode: "T7" },
  { AirlineName: "Transportes Aereos Nuequen", AirlineCode: "T8" },
  { AirlineName: "Varmlandsflyg", AirlineCode: "T9" },
  { AirlineName: "Taca International Airlines", AirlineCode: "TA" },
  { AirlineName: "Jetairfly.com", AirlineCode: "TB" },
  { AirlineName: "Air Tanzania Corp", AirlineCode: "TC" },
  { AirlineName: "ATLANTIS EUROPEAN AIRWAYS", AirlineCode: "TD" },
  { AirlineName: "Lithuanian Airlines", AirlineCode: "TE" },
  { AirlineName: "Malmo Aviation", AirlineCode: "TF" },
  { AirlineName: "Thai Airways International", AirlineCode: "TG" },
  { AirlineName: "British Regional Airlines", AirlineCode: "TH" },
  { AirlineName: "KINGFISHER AIRLINES {INT}", AirlineCode: "TI" },
  { AirlineName: "Tradewind Aviation", AirlineCode: "TJ" },
  { AirlineName: "Turkish Airlines", AirlineCode: "TK" },
  { AirlineName: "Airnorth Reg", AirlineCode: "TL" },
  { AirlineName: "Lam Linhas Aereas De Mocambique", AirlineCode: "TM" },
  { AirlineName: "Air Tahiti Nui", AirlineCode: "TN" },
  { AirlineName: "Transavia France", AirlineCode: "TO" },
  { AirlineName: "Air Portugal", AirlineCode: "TP" },
  { AirlineName: "Tandem Aero", AirlineCode: "TQ" },
  { AirlineName: "Scoot", AirlineCode: "TR" },
  { AirlineName: "Air Transat A.T.", AirlineCode: "TS" },
  { AirlineName: "Tigerair Australia", AirlineCode: "TT" },
  { AirlineName: "Tunis Air", AirlineCode: "TU" },
  { AirlineName: "Virgin Expres", AirlineCode: "TV" },
  { AirlineName: "TWAY AIR", AirlineCode: "TW" },
  { AirlineName: "Air Caraibes", AirlineCode: "TX" },
  { AirlineName: "Air Caledonia", AirlineCode: "TY" },
  { AirlineName: "Scoot", AirlineCode: "TZ" },
  { AirlineName: "Easyjet Airline Company", AirlineCode: "U2" },
  { AirlineName: "Buryat Airlines", AirlineCode: "U4" },
  { AirlineName: "USA 3000 Airlines", AirlineCode: "U5" },
  { AirlineName: "Ural Airlines", AirlineCode: "U6" },
  { AirlineName: "Air Uganda", AirlineCode: "U7" },
  { AirlineName: "Armavia", AirlineCode: "U8" },
  { AirlineName: "Tatarstan", AirlineCode: "U9" },
  { AirlineName: "United Airlines", AirlineCode: "UA" },
  { AirlineName: "Myanma Airway", AirlineCode: "UB" },
  { AirlineName: "Linea Aerea Del Cobre", AirlineCode: "UC" },
  { AirlineName: "Hex Air", AirlineCode: "UD" },
  { AirlineName: "Transeuropean Airlines", AirlineCode: "UE" },
  { AirlineName: "Ukranian-Mediterranean Airlines", AirlineCode: "UF" },
  { AirlineName: "Tuninter", AirlineCode: "UG" },
  { AirlineName: "US Helicopter", AirlineCode: "UH" },
  { AirlineName: "Auric Air", AirlineCode: "UI" },
  { AirlineName: "Aerosanta Airlines", AirlineCode: "UJ" },
  { AirlineName: "Sri Lankan Airlines", AirlineCode: "UL" },
  { AirlineName: "Air Zimbabwe", AirlineCode: "UM" },
  { AirlineName: "Transaero", AirlineCode: "UN" },
  { AirlineName: "Hong Kong Express Airways", AirlineCode: "UO" },
  { AirlineName: "Bahamasair", AirlineCode: "UP" },
  { AirlineName: "O'Connor Airlines", AirlineCode: "UQ" },
  { AirlineName: "US Airways", AirlineCode: "US" },
  { AirlineName: "UT Air", AirlineCode: "UT" },
  { AirlineName: "Air Austral", AirlineCode: "UU" },
  { AirlineName: "Helicopteros Del Sureste", AirlineCode: "UV" },
  { AirlineName: "Perimeter Aviation", AirlineCode: "UW" },
  { AirlineName: "Air Europa", AirlineCode: "UX" },
  { AirlineName: "Cameroon Airlines", AirlineCode: "UY" },
  { AirlineName: "U. P. Air", AirlineCode: "UZ" },
  { AirlineName: "Conviasa", AirlineCode: "V0" },
  { AirlineName: "Vision Airlines", AirlineCode: "V2" },
  { AirlineName: "Carpatair", AirlineCode: "V3" },
  { AirlineName: "Vieques Air Link", AirlineCode: "V4" },
  { AirlineName: "Ventura Airconnect", AirlineCode: "V5" },
  { AirlineName: "VI AIR LINK", AirlineCode: "V6" },
  { AirlineName: "Volotea", AirlineCode: "V7" },
  { AirlineName: "TAPSA Aviacion", AirlineCode: "V8" },
  { AirlineName: "Bashkir Airlines", AirlineCode: "V9" },
  { AirlineName: "Virgin Australia", AirlineCode: "VA" },
  { AirlineName: "Maersk Air Lt", AirlineCode: "VB" },
  { AirlineName: "Servivensa", AirlineCode: "VC" },
  { AirlineName: "Aerovias Venezulanas", AirlineCode: "VE" },
  { AirlineName: "Nevis Express", AirlineCode: "VF" },
  { AirlineName: "VLM Airlines", AirlineCode: "VG" },
  { AirlineName: "Aeropostal Alas De Venezue", AirlineCode: "VH" },
  { AirlineName: "VietJet Air", AirlineCode: "VJ" },
  { AirlineName: "Virgin Express Ireland.", AirlineCode: "VK" },
  { AirlineName: "Med-View Airline", AirlineCode: "VL" },
  { AirlineName: "Regional Airlines", AirlineCode: "VM" },
  { AirlineName: "Vietnam Airlines", AirlineCode: "VN" },
  { AirlineName: "Tyrolean Air", AirlineCode: "VO" },
  { AirlineName: "Vasp Brazilian Airlines", AirlineCode: "VP" },
  { AirlineName: "Novo Air", AirlineCode: "VQ" },
  { AirlineName: "Transportes Aereos De Cabo Verde", AirlineCode: "VR" },
  { AirlineName: "Virgin Atlantic Airways", AirlineCode: "VS" },
  { AirlineName: "Air Tahiti", AirlineCode: "VT" },
  { AirlineName: "Air Ivoire", AirlineCode: "VU" },
  { AirlineName: "Aerosvit Airlines", AirlineCode: "VV" },
  { AirlineName: "Aeromar Airlines", AirlineCode: "VW" },
  { AirlineName: "Virgin America", AirlineCode: "VX" },
  { AirlineName: "Vueling Airlines", AirlineCode: "VY" },
  { AirlineName: "Air Tours Intl Airways", AirlineCode: "VZ" },
  { AirlineName: "World Airline", AirlineCode: "W2" },
  { AirlineName: "Arik Air", AirlineCode: "W3" },
  { AirlineName: "LC Perú", AirlineCode: "W4" },
  { AirlineName: "Mahan Air", AirlineCode: "W5" },
  { AirlineName: "Wizz Air", AirlineCode: "W6" },
  { AirlineName: "Sayakhat Air Company", AirlineCode: "W7" },
  { AirlineName: "Air Bagan", AirlineCode: "W9" },
  { AirlineName: "Klm Cityhoppe", AirlineCode: "WA" },
  { AirlineName: "Rwandair Express", AirlineCode: "WB" },
  { AirlineName: "Islena Airl", AirlineCode: "WC" },
  { AirlineName: "Halisa Air", AirlineCode: "WD" },
  { AirlineName: "Thai Smile Airways", AirlineCode: "WE" },
  { AirlineName: "Wideroes Flyveselskap A/S", AirlineCode: "WF" },
  { AirlineName: "SUNWING AIRLINES INC", AirlineCode: "WG" },
  { AirlineName: "China N West", AirlineCode: "WH" },
  { AirlineName: "WHITE AIRWAYS S.A.", AirlineCode: "WI" },
  { AirlineName: "Labrador Airways", AirlineCode: "WJ" },
  { AirlineName: "American Falcon S.A.", AirlineCode: "WK" },
  { AirlineName: "Aeroperlas", AirlineCode: "WL" },
  { AirlineName: "Windward Islands Airways Intl", AirlineCode: "WM" },
  { AirlineName: "Southwest Airlines Dallas", AirlineCode: "WN" },
  { AirlineName: "Island Air", AirlineCode: "WP" },
  { AirlineName: "Romavia", AirlineCode: "WQ" },
  { AirlineName: "Royal Tongan", AirlineCode: "WR" },
  { AirlineName: "Westjet Airlines", AirlineCode: "WS" },
  { AirlineName: "Nigeria Airways", AirlineCode: "WT" },
  { AirlineName: "Aero Vip", AirlineCode: "WV" },
  { AirlineName: "WOW AIR", AirlineCode: "WW" },
  { AirlineName: "Cityjet", AirlineCode: "WX" },
  { AirlineName: "Oman Aviation", AirlineCode: "WY" },
  { AirlineName: "Acvila Air", AirlineCode: "WZ" },
  { AirlineName: "TUIfly", AirlineCode: "X3" },
  { AirlineName: "Cronus Air", AirlineCode: "X5" },
  { AirlineName: "Exec Air Inc. of Naples", AirlineCode: "X7" },
  { AirlineName: "Khors Air Company", AirlineCode: "X9" },
  { AirlineName: "Corendon Airlines", AirlineCode: "XC" },
  { AirlineName: "Vladivostok Air", AirlineCode: "XF" },
  { AirlineName: "SunExpress Deutschland", AirlineCode: "XG" },
  { AirlineName: "Hndlg Angent", AirlineCode: "XH" },
  { AirlineName: "Air India Expres {Intl}", AirlineCode: "XI" },
  { AirlineName: "Thai AirAsia X", AirlineCode: "XJ" },
  { AirlineName: "Compagnie Corse Mediterranee", AirlineCode: "XK" },
  { AirlineName: "Lanecuador", AirlineCode: "XL" },
  { AirlineName: "Alitalia Express", AirlineCode: "XM" },
  { AirlineName: "Xpress Air", AirlineCode: "XN" },
  { AirlineName: "China Xinjiang Airl", AirlineCode: "XO" },
  { AirlineName: "SunExpress", AirlineCode: "XQ" },
  { AirlineName: "Skywest Airlines", AirlineCode: "XR" },
  { AirlineName: "Klm Exel", AirlineCode: "XT" },
  { AirlineName: "BVI Airways", AirlineCode: "xv" },
  { AirlineName: "NokScoot", AirlineCode: "XW" },
  { AirlineName: "FLYNAS", AirlineCode: "XY" },
  { AirlineName: "SOUTH AFRICAN EXPRESS", AirlineCode: "XZ" },
  { AirlineName: "Alliance Air", AirlineCode: "Y2" },
  { AirlineName: "Eagle Aviatio", AirlineCode: "Y4" },
  { AirlineName: "JSC Airline Taimyr", AirlineCode: "Y7" },
  { AirlineName: "Passaredo Transportes", AirlineCode: "Y8" },
  { AirlineName: "Trans Air Congo", AirlineCode: "Y9" },
  { AirlineName: "South African Express Airlines", AirlineCode: "YB" },
  { AirlineName: "Yamal Airlines", AirlineCode: "YC" },
  { AirlineName: "Gomelavia", AirlineCode: "YD" },
  { AirlineName: "YAN AIR", AirlineCode: "YE" },
  { AirlineName: "Air Sunshine", AirlineCode: "YI" },
  { AirlineName: "National Air", AirlineCode: "YJ" },
  { AirlineName: "Avia Traffic Company", AirlineCode: "YK" },
  { AirlineName: "Montenegro Airlines", AirlineCode: "YM" },
  { AirlineName: "Air Creebec", AirlineCode: "YN" },
  { AirlineName: "Heli Air Monaco", AirlineCode: "YO" },
  { AirlineName: "Aero Lloyd", AirlineCode: "YP" },
  { AirlineName: "Polet Airlines", AirlineCode: "YQ" },
  { AirlineName: "Scenic Air Lines", AirlineCode: "YR" },
  { AirlineName: "Proteus", AirlineCode: "YS" },
  { AirlineName: "YETI AIRLINES", AirlineCode: "YT" },
  { AirlineName: "EUROATLANTIC AIRWAYS", AirlineCode: "YU" },
  { AirlineName: "Mesa Aviation Services", AirlineCode: "YV" },
  { AirlineName: "Air Nostrum", AirlineCode: "YW" },
  { AirlineName: "Midwest Express Airlines", AirlineCode: "YX" },
  { AirlineName: "AirAsia Zest", AirlineCode: "Z2" },
  { AirlineName: "Promech", AirlineCode: "Z3" },
  { AirlineName: "Tayfunair", AirlineCode: "Z4" },
  { AirlineName: "Gmg Airlines", AirlineCode: "Z5" },
  {
    AirlineName: "Dnieproavia Joint Stock Aviation Company",
    AirlineCode: "Z6",
  },
  { AirlineName: "Flyafrica.com", AirlineCode: "Z7" },
  { AirlineName: "Pulkovo Aviation Enterprise", AirlineCode: "Z8" },
  { AirlineName: "JSC BEK AIR", AirlineCode: "Z9" },
  { AirlineName: "Sky Angkor Airlines", AirlineCode: "ZA" },
  { AirlineName: "Monarch Airline", AirlineCode: "ZB" },
  { AirlineName: "KORONGO AIRLINES", AirlineCode: "ZC" },
  { AirlineName: "EASTAR JET", AirlineCode: "ZE" },
  { AirlineName: "Groznyy Avia", AirlineCode: "ZG" },
  { AirlineName: "Shenzhen Airlines", AirlineCode: "ZH" },
  { AirlineName: "Aigle Azur Transport Ariens", AirlineCode: "ZI" },
  { AirlineName: "Zambezi Airlines", AirlineCode: "ZJ" },
  { AirlineName: "Great Lakes", AirlineCode: "ZK" },
  { AirlineName: "Hazelton Air Services Pty", AirlineCode: "ZL" },
  { AirlineName: "AIR MANAS", AirlineCode: "ZM" },
  { AirlineName: "Eagle Air", AirlineCode: "ZN" },
  { AirlineName: "Zoom Air", AirlineCode: "ZO" },
  { AirlineName: "Air St Thomas", AirlineCode: "ZP" },
  { AirlineName: "Muk Air", AirlineCode: "ZR" },
  { AirlineName: "Sama Airlines", AirlineCode: "ZS" },
  { AirlineName: "Air Zambezi", AirlineCode: "ZT" },
  { AirlineName: "Air Midwest", AirlineCode: "ZV" },
  { AirlineName: "Air Wisconsin", AirlineCode: "ZW" },
  { AirlineName: "Air British Columbia", AirlineCode: "ZX" },
  { AirlineName: "Ada Air", AirlineCode: "ZY" },
  { AirlineName: "Akasa Air", AirlineCode: "QP" },
  { AirlineName: "FlyBig", AirlineCode: "S9" },
  {
    AirlineCode: "00",
    AirlineName: "00",
  },
  {
    AirlineCode: "02",
    AirlineName: "02",
  },
  {
    AirlineCode: "05",
    AirlineName: "05",
  },
  {
    AirlineCode: "0A",
    AirlineName: "Amber Air",
  },
  {
    AirlineCode: "0B",
    AirlineName: "Blue Air",
  },
  {
    AirlineCode: "0C",
    AirlineName: "IBL Aviation",
  },
  {
    AirlineCode: "0D",
    AirlineName: "Darwin Airline",
  },
  {
    AirlineCode: "0F",
    AirlineName: "0F",
  },
  {
    AirlineCode: "0H",
    AirlineName: "0H",
  },
  {
    AirlineCode: "0I",
    AirlineName: "0I",
  },
  {
    AirlineCode: "0J",
    AirlineName: "Jetclub",
  },
  {
    AirlineCode: "0O",
    AirlineName: "0O",
  },
  {
    AirlineCode: "0V",
    AirlineName: "0V",
  },
  {
    AirlineCode: "0Y",
    AirlineName: "0Y",
  },
  {
    AirlineCode: "1A",
    AirlineName: "Amadeus Global Travel Distribution",
  },
  {
    AirlineCode: "1B",
    AirlineName: "Abacus International",
  },
  {
    AirlineCode: "1C",
    AirlineName: "Electronic Data Systems",
  },
  {
    AirlineCode: "1D",
    AirlineName: "Radixx Solutions International",
  },
  {
    AirlineCode: "1E",
    AirlineName: "Travelsky Technology",
  },
  {
    AirlineCode: "1F",
    AirlineName: "INFINI Travel Information",
  },
  {
    AirlineCode: "1G",
    AirlineName: "Travelport",
  },
  {
    AirlineCode: "1H",
    AirlineName: "Sirena-Travel",
  },
  {
    AirlineCode: "1I",
    AirlineName: "NetJets Aviation",
  },
  {
    AirlineCode: "1K",
    AirlineName: "Sutra",
  },
  {
    AirlineCode: "1L",
    AirlineName: "Navitaire Open Skies",
  },
  {
    AirlineCode: "1M",
    AirlineName: "Sirena JSC",
  },
  {
    AirlineCode: "1N",
    AirlineName: "Navitaire",
  },
  {
    AirlineCode: "1P",
    AirlineName: "Worldspan",
  },
  {
    AirlineCode: "1Q",
    AirlineName: "Sirena",
  },
  {
    AirlineCode: "1R",
    AirlineName: "Bird Information Systems",
  },
  {
    AirlineCode: "1S",
    AirlineName: "Sabre",
  },
  {
    AirlineCode: "1T",
    AirlineName: "East-Line JSC",
  },
  {
    AirlineCode: "1U",
    AirlineName: "ITA Software",
  },
  {
    AirlineCode: "1W",
    AirlineName: "Sabre",
  },
  {
    AirlineCode: "1Y",
    AirlineName: "Electronic Data Systems",
  },
  {
    AirlineCode: "1Z",
    AirlineName: "Fantasia Info Network",
  },
  {
    AirlineCode: "2A",
    AirlineName: "Deutsche Bahn",
  },
  {
    AirlineCode: "2B",
    AirlineName: "Albawings",
  },
  {
    AirlineCode: "2C",
    AirlineName: "SNCF",
  },
  {
    AirlineCode: "2D",
    AirlineName: "Dynamic Airways",
  },
  {
    AirlineCode: "2F",
    AirlineName: "TWO TAXI AEREO",
  },
  {
    AirlineCode: "2G",
    AirlineName: "Angara Airlines",
  },
  {
    AirlineCode: "2H",
    AirlineName: "Thalys",
  },
  {
    AirlineCode: "2I",
    AirlineName: "21 Air",
  },
  {
    AirlineCode: "2J",
    AirlineName: "Air Burkina",
  },
  {
    AirlineCode: "2K",
    AirlineName: "Aerolineas Galapagos",
  },
  {
    AirlineCode: "2L",
    AirlineName: "Helvetic Airways",
  },
  {
    AirlineCode: "2M",
    AirlineName: "Moldavian Airlines",
  },
  {
    AirlineCode: "2N",
    AirlineName: "NextJet",
  },
  {
    AirlineCode: "2O",
    AirlineName: "Redemption",
  },
  {
    AirlineCode: "2P",
    AirlineName: "Airphill Express",
  },
  {
    AirlineCode: "2Q",
    AirlineName: "Air Cargo Carriers",
  },
  {
    AirlineCode: "2R",
    AirlineName: "Via Rail Canada",
  },
  {
    AirlineCode: "2S",
    AirlineName: "Southwind Airlines ",
  },
  {
    AirlineCode: "2T",
    AirlineName: "Haiti Ambassador Airlines",
  },
  {
    AirlineCode: "2U",
    AirlineName: "Air Guinee Express",
  },
  {
    AirlineCode: "2V",
    AirlineName: "Amtrak",
  },
  {
    AirlineCode: "2W",
    AirlineName: "Welcome Air",
  },
  {
    AirlineCode: "2Z",
    AirlineName: "Chang'an Airlines",
  },
  {
    AirlineCode: "31",
    AirlineName: "Aerolineas Del Sur",
  },
  {
    AirlineCode: "3A",
    AirlineName: "Chu Kong Passenger Transport",
  },
  {
    AirlineCode: "3B",
    AirlineName: "Job Air",
  },
  {
    AirlineCode: "3C",
    AirlineName: "Air Chathams",
  },
  {
    AirlineCode: "3E",
    AirlineName: "Air Choice One",
  },
  {
    AirlineCode: "3F",
    AirlineName: "FlyOne Armenia",
  },
  {
    AirlineCode: "3G",
    AirlineName: "Gambia Bird Airlines LTD",
  },
  {
    AirlineCode: "3H",
    AirlineName: "Air Inuit",
  },
  {
    AirlineCode: "3J",
    AirlineName: "Jubba Airways",
  },
  {
    AirlineCode: "3K",
    AirlineName: "Jetstar Asia Airways",
  },
  {
    AirlineCode: "3L",
    AirlineName: "Air Arabia Abu Dhabi",
  },
  {
    AirlineCode: "3M",
    AirlineName: "Silver Airways",
  },
  {
    AirlineCode: "3N",
    AirlineName: "Air Urga",
  },
  {
    AirlineCode: "3O",
    AirlineName: "Air Arabia Maroc",
  },
  {
    AirlineCode: "3P",
    AirlineName: "Tiara Air",
  },
  {
    AirlineCode: "3Q",
    AirlineName: "KC International Airlines",
  },
  {
    AirlineCode: "3R",
    AirlineName: "Avior Regional",
  },
  {
    AirlineCode: "3S",
    AirlineName: "Air Antilles Express",
  },
  {
    AirlineCode: "3T",
    AirlineName: "Tarco Air",
  },
  {
    AirlineCode: "3U",
    AirlineName: "Sichuan Airlines",
  },
  {
    AirlineCode: "3V",
    AirlineName: "TNT Airways",
  },
  {
    AirlineCode: "3W",
    AirlineName: "Malawian Airlines",
  },
  {
    AirlineCode: "3X",
    AirlineName: "Japan Air Commuter",
  },
  {
    AirlineCode: "4A",
    AirlineName: "Aero Transporte",
  },
  {
    AirlineCode: "4B",
    AirlineName: "Boutique Air",
  },
  {
    AirlineCode: "4C",
    AirlineName: "Latam Airlines Colombia",
  },
  {
    AirlineCode: "4D",
    AirlineName: "Air Sinai",
  },
  {
    AirlineCode: "4F",
    AirlineName: "Air City",
  },
  {
    AirlineCode: "4G",
    AirlineName: "Gazpromavia",
  },
  {
    AirlineCode: "4H",
    AirlineName: "HiSky",
  },
  {
    AirlineCode: "4J",
    AirlineName: "Jetair Caribbean",
  },
  {
    AirlineCode: "4K",
    AirlineName: "Kenn Borek Air",
  },
  {
    AirlineCode: "4L",
    AirlineName: "4L",
  },
  {
    AirlineCode: "4M",
    AirlineName: "Mavi Gok",
  },
  {
    AirlineCode: "4N",
    AirlineName: "Air North Charter - Canada",
  },
  {
    AirlineCode: "4O",
    AirlineName: "Interjet",
  },
  {
    AirlineCode: "4P",
    AirlineName: "Public Charters",
  },
  {
    AirlineCode: "4Q",
    AirlineName: "Safi Airlines",
  },
  {
    AirlineCode: "4R",
    AirlineName: "Renef Viajeros",
  },
  {
    AirlineCode: "4S",
    AirlineName: "Star Airways",
  },
  {
    AirlineCode: "4T",
    AirlineName: "Belair Airlines",
  },
  {
    AirlineCode: "4U",
    AirlineName: "Germanwings",
  },
  {
    AirlineCode: "4V",
    AirlineName: "Fly Gangwon",
  },
  {
    AirlineCode: "4Y",
    AirlineName: "EW Discover",
  },
  {
    AirlineCode: "4Z",
    AirlineName: "South African Airlink",
  },
  null,
  {
    AirlineCode: "5A",
    AirlineName: "Alpine Air Express",
  },
  {
    AirlineCode: "5C",
    AirlineName: "Nature Air",
  },
  {
    AirlineCode: "5D",
    AirlineName: "Aerolitoral",
  },
  {
    AirlineCode: "5F",
    AirlineName: "Fly One",
  },
  {
    AirlineCode: "5G",
    AirlineName: "Aerocuahonte",
  },
  {
    AirlineCode: "5H",
    AirlineName: "Fly540",
  },
  {
    AirlineCode: "5I",
    AirlineName: "Alsa Grupo SLU",
  },
  {
    AirlineCode: "5J",
    AirlineName: "Cebu Pacific",
  },
  {
    AirlineCode: "5K",
    AirlineName: "Hi Fly",
  },
  {
    AirlineCode: "5L",
    AirlineName: "Fly Salone",
  },
  {
    AirlineCode: "5M",
    AirlineName: "Montserrat Airways",
  },
  {
    AirlineCode: "5N",
    AirlineName: "Nordavia",
  },
  {
    AirlineCode: "5O",
    AirlineName: "Asl Airlines France",
  },
  {
    AirlineCode: "5Q",
    AirlineName: "5Q",
  },
  {
    AirlineCode: "5S",
    AirlineName: "5S",
  },
  {
    AirlineCode: "5T",
    AirlineName: "Canadian North",
  },
  {
    AirlineCode: "5U",
    AirlineName: "TAG Airline",
  },
  {
    AirlineCode: "5V",
    AirlineName: "840 Everts",
  },
  {
    AirlineCode: "5W",
    AirlineName: "Wizz Air Abu Dhabi",
  },
  {
    AirlineCode: "5X",
    AirlineName: "United Parcel Service",
  },
  {
    AirlineCode: "5Y",
    AirlineName: "Atlas Air",
  },
  {
    AirlineCode: "5Z",
    AirlineName: "Cemair",
  },
  {
    AirlineCode: "6A",
    AirlineName: "Armenia Airways",
  },
  {
    AirlineCode: "6B",
    AirlineName: "TUIfly Nordic",
  },
  {
    AirlineCode: "6D",
    AirlineName: "Travel Service Slovensko",
  },
  {
    AirlineCode: "6E",
    AirlineName: "IndiGo Airlines",
  },
  {
    AirlineCode: "6F",
    AirlineName: "Primera Air Nordic",
  },
  {
    AirlineCode: "6G",
    AirlineName: "Executive Express",
  },
  {
    AirlineCode: "6H",
    AirlineName: "Israir",
  },
  {
    AirlineCode: "6I",
    AirlineName: "Air Alsie",
  },
  {
    AirlineCode: "6J",
    AirlineName: "Solaseed Air",
  },
  {
    AirlineCode: "6K",
    AirlineName: "Kyrgyz Trans Avia",
  },
  {
    AirlineCode: "6N",
    AirlineName: "Niger Airlines",
  },
  {
    AirlineCode: "6O",
    AirlineName: "Air Satellite",
  },
  {
    AirlineCode: "6P",
    AirlineName: "Club Air",
  },
  {
    AirlineCode: "6Q",
    AirlineName: "Cham Wings Airlines",
  },
  {
    AirlineCode: "6R",
    AirlineName: "Mirny Air",
  },
  {
    AirlineCode: "6S",
    AirlineName: "Saudi Gulf Airlines",
  },
  {
    AirlineCode: "6U",
    AirlineName: "Air Cargo Germany",
  },
  {
    AirlineCode: "6V",
    AirlineName: "Avanza",
  },
  {
    AirlineCode: "6W",
    AirlineName: "Saratov Airlines Joint Stock Company",
  },
  {
    AirlineCode: "6Y",
    AirlineName: "Smartlynx Airlines",
  },
  {
    AirlineCode: "6Z",
    AirlineName: "Eurasia Air",
  },
  {
    AirlineCode: "7A",
    AirlineName: "Air Jet",
  },
  {
    AirlineCode: "7B",
    AirlineName: "Fly Blue Crane",
  },
  {
    AirlineCode: "7C",
    AirlineName: "Jeju Air",
  },
  {
    AirlineCode: "7D",
    AirlineName: "MGC Aviation",
  },
  {
    AirlineCode: "7E",
    AirlineName: "Sylt Air GmbH",
  },
  {
    AirlineCode: "7F",
    AirlineName: "First Air",
  },
  {
    AirlineCode: "7G",
    AirlineName: "Star Flyer",
  },
  {
    AirlineCode: "7H",
    AirlineName: "Ravn Alaska",
  },
  {
    AirlineCode: "7I",
    AirlineName: "Insel Air",
  },
  {
    AirlineCode: "7J",
    AirlineName: "Tajik Air",
  },
  {
    AirlineCode: "7K",
    AirlineName: "Kogalymavia Air Company",
  },
  {
    AirlineCode: "7L",
    AirlineName: "Aerocaribbean",
  },
  {
    AirlineCode: "7M",
    AirlineName: "MayAir",
  },
  null,
  {
    AirlineCode: "7N",
    AirlineName: "Pan American World",
  },
  {
    AirlineCode: "7O",
    AirlineName: "Travel Service",
  },
  {
    AirlineCode: "7P",
    AirlineName: "7P",
  },
  {
    AirlineCode: "7Q",
    AirlineName: "Elite Airways",
  },
  {
    AirlineCode: "7R",
    AirlineName: "Rusline",
  },
  {
    AirlineCode: "7S",
    AirlineName: "Ryan Air Service",
  },
  {
    AirlineCode: "7T",
    AirlineName: "Trenitalia",
  },
  {
    AirlineCode: "7W",
    AirlineName: "Wind Rose Aviation",
  },
  {
    AirlineCode: "7Y",
    AirlineName: "Mann Yadanarpon Airlines",
  },
  {
    AirlineCode: "7Z",
    AirlineName: "7Z",
  },
  {
    AirlineCode: "81",
    AirlineName: "81",
  },
  {
    AirlineCode: "89",
    AirlineName: "89",
  },
  {
    AirlineCode: "8A",
    AirlineName: "Panama Airways",
  },
  {
    AirlineCode: "8B",
    AirlineName: "TransNusa",
  },
  {
    AirlineCode: "8C",
    AirlineName: "Air Transport International",
  },
  {
    AirlineCode: "8D",
    AirlineName: "Servant Air",
  },
  {
    AirlineCode: "8E",
    AirlineName: "Bering Air",
  },
  {
    AirlineCode: "8F",
    AirlineName: "Stp Airways",
  },
  {
    AirlineCode: "8G",
    AirlineName: "Instone Air",
  },
  {
    AirlineCode: "8H",
    AirlineName: "BH Air",
  },
  {
    AirlineCode: "8I",
    AirlineName: "Insel Air Aruba",
  },
  {
    AirlineCode: "8J",
    AirlineName: "Linea Aerea Eco Jet",
  },
  {
    AirlineCode: "8L",
    AirlineName: "Lucky Air",
  },
  {
    AirlineCode: "8M",
    AirlineName: "Myanmar Airways International",
  },
  {
    AirlineCode: "8N",
    AirlineName: "Regional Air Services",
  },
  {
    AirlineCode: "8O",
    AirlineName: "West Coast Air",
  },
  {
    AirlineCode: "8P",
    AirlineName: "Pacific Coastal Airlines",
  },
  {
    AirlineCode: "8Q",
    AirlineName: "Onur Air",
  },
  {
    AirlineCode: "8R",
    AirlineName: "8R",
  },
  {
    AirlineCode: "8S",
    AirlineName: "Scorpio Aviation",
  },
  {
    AirlineCode: "8T",
    AirlineName: "Air Tindi",
  },
  {
    AirlineCode: "8U",
    AirlineName: "Afriqiyah Airways",
  },
  {
    AirlineCode: "8V",
    AirlineName: "Wright Air Service",
  },
  {
    AirlineCode: "8W",
    AirlineName: "Fly Always",
  },
  {
    AirlineCode: "8Y",
    AirlineName: "Air Burundi",
  },
  {
    AirlineCode: "8Z",
    AirlineName: "Wizz Air Bulgaria",
  },
  {
    AirlineCode: "9A",
    AirlineName: "Eagle Express Air Charter",
  },
  {
    AirlineCode: "9B",
    AirlineName: "Access Rail",
  },
  {
    AirlineCode: "9C",
    AirlineName: "Spring Airlines",
  },
  {
    AirlineCode: "9E",
    AirlineName: "Endeavor Air",
  },
  {
    AirlineCode: "9F",
    AirlineName: "Eurostar",
  },
  {
    AirlineCode: "9H",
    AirlineName: "Changan Airlines",
  },
  {
    AirlineCode: "9I",
    AirlineName: "Alliance Air",
  },
  {
    AirlineCode: "9K",
    AirlineName: "Cape Air",
  },
  {
    AirlineCode: "9L",
    AirlineName: "West Link Airways",
  },
  {
    AirlineCode: "9M",
    AirlineName: "Central Mountain Air",
  },
  {
    AirlineCode: "9N",
    AirlineName: "Tropic Air",
  },
  {
    AirlineCode: "9O",
    AirlineName: "National Airways Cameroon",
  },
  {
    AirlineCode: "9P",
    AirlineName: "Air Arabia Jordan",
  },
  {
    AirlineCode: "9Q",
    AirlineName: "Caicos Express Airways",
  },
  {
    AirlineCode: "9R",
    AirlineName: "Phuket Air",
  },
  {
    AirlineCode: "9T",
    AirlineName: "Transwest Air",
  },
  {
    AirlineCode: "9U",
    AirlineName: "Air Moldova",
  },
  {
    AirlineCode: "9V",
    AirlineName: "Vipair Airlines",
  },
  {
    AirlineCode: "9W",
    AirlineName: "Jet Airways",
  },
  {
    AirlineCode: "9X",
    AirlineName: "Southern Airways Express",
  },
  {
    AirlineCode: "9Y",
    AirlineName: "National Airways",
  },
  {
    AirlineCode: "A0",
    AirlineName: "A0",
  },
  {
    AirlineCode: "A1",
    AirlineName: "A.P.G. Distribution System",
  },
  {
    AirlineCode: "A2",
    AirlineName: "Astra Airlines",
  },
  {
    AirlineCode: "A3",
    AirlineName: "Aegean Airlines",
  },
  {
    AirlineCode: "A4",
    AirlineName: "AZIMUTH Airlines",
  },
  {
    AirlineCode: "A5",
    AirlineName: "Hop",
  },
  {
    AirlineCode: "A6",
    AirlineName: "Yunnan Hong Tu Airlines",
  },
  {
    AirlineCode: "A7",
    AirlineName: "Air Niamey",
  },
  {
    AirlineCode: "A8",
    AirlineName: "Benin Golf Air",
  },
  {
    AirlineCode: "A9",
    AirlineName: "Georgian Airways",
  },
  {
    AirlineCode: "AA",
    AirlineName: "American Airlines",
  },
  {
    AirlineCode: "AB",
    AirlineName: "Air Berlin",
  },
  {
    AirlineCode: "AC",
    AirlineName: "Air Canada",
  },
  {
    AirlineCode: "AD",
    AirlineName: "Azul Linhas Aéreas Brasileiras",
  },
  {
    AirlineCode: "AE",
    AirlineName: "Mandarin Airlines",
  },
  {
    AirlineCode: "AF",
    AirlineName: "Air France",
  },
  {
    AirlineCode: "AG",
    AirlineName: "Aruba Airlines",
  },
  {
    AirlineCode: "AH",
    AirlineName: "Air Algérie",
  },
  {
    AirlineCode: "AI",
    AirlineName: "Air India Limited",
  },
  {
    AirlineCode: "AJ",
    AirlineName: "Aero Contractors",
  },
  {
    AirlineCode: "AJ0",
    AirlineName: "AJ0",
  },
  {
    AirlineCode: "AJTK",
    AirlineName: "Anadolu Jet",
  },
  {
    AirlineCode: "AK",
    AirlineName: "AirAsia",
  },
  {
    AirlineCode: "AL",
    AirlineName: "Air Leisure",
  },
  {
    AirlineCode: "AM",
    AirlineName: "Aeromexico",
  },
  {
    AirlineCode: "AN",
    AirlineName: "Advanced Air",
  },
  {
    AirlineCode: "AO",
    AirlineName: "Australian Airlines",
  },
  {
    AirlineCode: "AP",
    AirlineName: "AlbaStar",
  },
  {
    AirlineCode: "AQ",
    AirlineName: "9 Air",
  },
  {
    AirlineCode: "AR",
    AirlineName: "Aerolíneas Argentinas",
  },
  {
    AirlineCode: "AS",
    AirlineName: "Alaska Airlines, Inc.",
  },
  {
    AirlineCode: "AT",
    AirlineName: "Royal Air Maroc",
  },
  {
    AirlineCode: "ATR",
    AirlineName: "Atrak",
  },
  {
    AirlineCode: "AU",
    AirlineName: "Canada Jetlines",
  },
  {
    AirlineCode: "AV",
    AirlineName: "Avianca",
  },
  {
    AirlineCode: "AW",
    AirlineName: "Africa World Airlines",
  },
  {
    AirlineCode: "AX",
    AirlineName: "Trans States Airlines",
  },
  {
    AirlineCode: "AY",
    AirlineName: "Finnair",
  },
  {
    AirlineCode: "AZ",
    AirlineName: "ITA Airways",
  },
  {
    AirlineCode: "B0",
    AirlineName: "La Compagnie",
  },
  {
    AirlineCode: "B2",
    AirlineName: "Belavia Belarusian",
  },
  {
    AirlineCode: "B3",
    AirlineName: "Bellview Airlines",
  },
  {
    AirlineCode: "B4",
    AirlineName: "Zanair",
  },
  {
    AirlineCode: "B5",
    AirlineName: "Fly SAX",
  },
  {
    AirlineCode: "B6",
    AirlineName: "JetBlue Airways",
  },
  {
    AirlineCode: "B7",
    AirlineName: "Uni Airways",
  },
  {
    AirlineCode: "B8",
    AirlineName: "Eritrean Airlines",
  },
  {
    AirlineCode: "B9",
    AirlineName: "Iran Air Tour",
  },
  {
    AirlineCode: "BA",
    AirlineName: "British Airways",
  },
  {
    AirlineCode: "BB",
    AirlineName: "Seaborne Airlines",
  },
  {
    AirlineCode: "BC",
    AirlineName: "Skymark Airlines",
  },
  {
    AirlineCode: "BD",
    AirlineName: "BMI",
  },
  {
    AirlineCode: "BE",
    AirlineName: "Flybe",
  },
  {
    AirlineCode: "BF",
    AirlineName: "French Bee",
  },
  {
    AirlineCode: "BG",
    AirlineName: "Biman Bangladesh Airlines",
  },
  {
    AirlineCode: "BH",
    AirlineName: "Hawkair",
  },
  {
    AirlineCode: "BI",
    AirlineName: "Royal Brunei Airlines",
  },
  {
    AirlineCode: "BJ",
    AirlineName: "Nouvel Air Tunisie",
  },
  {
    AirlineCode: "BK",
    AirlineName: "Potomac Air",
  },
  {
    AirlineCode: "BL",
    AirlineName: "Pacific Airlines",
  },
  {
    AirlineCode: "BM",
    AirlineName: "BMI Regional",
  },
  {
    AirlineCode: "BN",
    AirlineName: "Horizon Airlines",
  },
  {
    AirlineCode: "BO",
    AirlineName: "Bouraq Indonesia Airlines",
  },
  {
    AirlineCode: "BP",
    AirlineName: "Air Botswana",
  },
  {
    AirlineCode: "BQ",
    AirlineName: "Bukovyna Airlines",
  },
  {
    AirlineCode: "BR",
    AirlineName: "EVA Air",
  },
  {
    AirlineCode: "BS",
    AirlineName: "US Bangla Airlines",
  },
  {
    AirlineCode: "BT",
    AirlineName: "Air Baltic",
  },
  {
    AirlineCode: "BU",
    AirlineName: "Buryat Airlines Aircompany",
  },
  {
    AirlineCode: "BV",
    AirlineName: "Blue Panorama Airlines",
  },
  {
    AirlineCode: "BW",
    AirlineName: "Caribbean Airlines",
  },
  {
    AirlineCode: "BX",
    AirlineName: "Air Busan",
  },
  {
    AirlineCode: "BY",
    AirlineName: "TUI Airways",
  },
  {
    AirlineCode: "BZ",
    AirlineName: "Blue Bird Airways",
  },
  {
    AirlineCode: "C2",
    AirlineName: "Ceiba Intercontinental",
  },
  {
    AirlineCode: "C3",
    AirlineName: "Independent Carrier (ICAR)",
  },
  {
    AirlineCode: "C4",
    AirlineName: "Zimex Aviation",
  },
  {
    AirlineCode: "C5",
    AirlineName: "CommutAir",
  },
  {
    AirlineCode: "C6",
    AirlineName: "CanJet",
  },
  {
    AirlineCode: "C7",
    AirlineName: "Cinnamon Air",
  },
  {
    AirlineCode: "C8",
    AirlineName: "Cronos Airlines",
  },
  {
    AirlineCode: "C9",
    AirlineName: "Cirrus Airlines",
  },
  {
    AirlineCode: "CA",
    AirlineName: "Air China",
  },
  {
    AirlineCode: "CB",
    AirlineName: "Kalitta Charters II",
  },
  {
    AirlineCode: "CC",
    AirlineName: "CM Airlines",
  },
  {
    AirlineCode: "CD",
    AirlineName: "Corendon Dutch Airlines",
  },
  {
    AirlineCode: "CE",
    AirlineName: "Nationwide Airlines",
  },
  {
    AirlineCode: "CF",
    AirlineName: "City Airline",
  },
  {
    AirlineCode: "CG",
    AirlineName: "Airlines PNG",
  },
  {
    AirlineCode: "CH",
    AirlineName: "Bemidji Airlines",
  },
  {
    AirlineCode: "CI",
    AirlineName: "China Airlines",
  },
  {
    AirlineCode: "CJ",
    AirlineName: "CityFlyer",
  },
  {
    AirlineCode: "CK",
    AirlineName: "China Cargo Airlines",
  },
  {
    AirlineCode: "CL",
    AirlineName: "Lufthansa CityLine",
  },
  {
    AirlineCode: "CM",
    AirlineName: "Copa Airlines",
  },
  {
    AirlineCode: "CN",
    AirlineName: "Grand China Air",
  },
  {
    AirlineCode: "CO",
    AirlineName: "Cobalt Airlines",
  },
  {
    AirlineCode: "CP",
    AirlineName: "Compass Airlines",
  },
  {
    AirlineCode: "CPN",
    AirlineName: "Caspian",
  },
  {
    AirlineCode: "CQ",
    AirlineName: "Coastal Travels",
  },
  {
    AirlineCode: "CR",
    AirlineName: "OAG",
  },
  {
    AirlineCode: "CS",
    AirlineName: "Continental Micronesia",
  },
  {
    AirlineCode: "CT",
    AirlineName: "Alitalia City Liner SPA",
  },
  {
    AirlineCode: "CU",
    AirlineName: "Cubana de Aviación",
  },
  {
    AirlineCode: "CV",
    AirlineName: "Cargolux",
  },
  {
    AirlineCode: "CW",
    AirlineName: "Air Marshall Islands",
  },
  {
    AirlineCode: "CX",
    AirlineName: "Cathay Pacific",
  },
  {
    AirlineCode: "CY",
    AirlineName: "Cyprus Airways",
  },
  {
    AirlineCode: "CZ",
    AirlineName: "China Southern Airlines",
  },
  {
    AirlineCode: "D2",
    AirlineName: "Severstal Air Company",
  },
  {
    AirlineCode: "D3",
    AirlineName: "Daallo Airlines",
  },
  {
    AirlineCode: "D4",
    AirlineName: "Alidaunia",
  },
  {
    AirlineCode: "D5",
    AirlineName: "Dauair",
  },
  {
    AirlineCode: "D6",
    AirlineName: "Interair South Africa",
  },
  {
    AirlineCode: "D7",
    AirlineName: "AirAsia X",
  },
  {
    AirlineCode: "D8",
    AirlineName: "Norwegian Air International Ltd.",
  },
  {
    AirlineCode: "D9",
    AirlineName: "Donavia",
  },
  {
    AirlineCode: "DA",
    AirlineName: "Air Georgia",
  },
  {
    AirlineCode: "DB",
    AirlineName: "Brit Air",
  },
  {
    AirlineCode: "DC",
    AirlineName: "Golden Air",
  },
  {
    AirlineCode: "DD",
    AirlineName: "Nok Air",
  },
  {
    AirlineCode: "DE",
    AirlineName: "Condor Flugdienst",
  },
  {
    AirlineCode: "DF",
    AirlineName: "Condor Berlin",
  },
  {
    AirlineCode: "DG",
    AirlineName: "Cebgo",
  },
  {
    AirlineCode: "DH",
    AirlineName: "Douniah Airlines",
  },
  {
    AirlineCode: "DI",
    AirlineName: "Norwegian Air",
  },
  {
    AirlineCode: "DJ",
    AirlineName: "Pacific Blue",
  },
  {
    AirlineCode: "DK",
    AirlineName: "Eastland Air",
  },
  {
    AirlineCode: "DL",
    AirlineName: "Delta Air Lines",
  },
  {
    AirlineCode: "DM",
    AirlineName: "Arajet",
  },
  {
    AirlineCode: "DN",
    AirlineName: "Norwegian Air Argentina",
  },
  {
    AirlineCode: "DO",
    AirlineName: "Discovery Airways",
  },
  {
    AirlineCode: "DP",
    AirlineName: "Pobeda",
  },
  {
    AirlineCode: "DQ",
    AirlineName: "Coastal Air",
  },
  {
    AirlineCode: "DR",
    AirlineName: "Ruili Airlines",
  },
  {
    AirlineCode: "DS",
    AirlineName: "easyJet Switzerland",
  },
  {
    AirlineCode: "DT",
    AirlineName: "TAAG Angola Airlines",
  },
  {
    AirlineCode: "DU",
    AirlineName: "Air Liaison",
  },
  {
    AirlineCode: "DV",
    AirlineName: "JSC Aircompany SCAT",
  },
  {
    AirlineCode: "DW",
    AirlineName: "Aero-Charter Ukraine",
  },
  {
    AirlineCode: "DX",
    AirlineName: "DAT Danish Air Transport",
  },
  {
    AirlineCode: "DY",
    AirlineName: "Norwegian Air Shuttle",
  },
  {
    AirlineCode: "DZ",
    AirlineName: "DONGHAI AIRLINES",
  },
  {
    AirlineCode: "E0",
    AirlineName: "Eos Airlines",
  },
  {
    AirlineCode: "E1",
    AirlineName: "Everbread",
  },
  {
    AirlineCode: "E2",
    AirlineName: "Eagle Atlantic Airlines",
  },
  {
    AirlineCode: "E3",
    AirlineName: "EGO Airways",
  },
  {
    AirlineCode: "E4",
    AirlineName: "Aero Asia International",
  },
  {
    AirlineCode: "E5",
    AirlineName: "Samara Airlines",
  },
  {
    AirlineCode: "E6",
    AirlineName: "Bringer Air Cargo Taxi Aéreo",
  },
  {
    AirlineCode: "E7",
    AirlineName: "Equaflight Service",
  },
  {
    AirlineCode: "E8",
    AirlineName: "Alpi Eagles",
  },
  {
    AirlineCode: "E9",
    AirlineName: "Iberojet",
  },
  {
    AirlineCode: "EA",
    AirlineName: "East Horizon Airlines",
  },
  {
    AirlineCode: "EB",
    AirlineName: "Wamos Air",
  },
  {
    AirlineCode: "EC",
    AirlineName: "Avialeasing Aviation Company",
  },
  {
    AirlineCode: "ED",
    AirlineName: "Airblue",
  },
  {
    AirlineCode: "EE",
    AirlineName: "Marabu Airlines",
  },
  {
    AirlineCode: "EF",
    AirlineName: "Far Eastern Air Transport",
  },
  {
    AirlineCode: "EG",
    AirlineName: "Ernest Airlines",
  },
  {
    AirlineCode: "EH",
    AirlineName: "Ana Wings",
  },
  {
    AirlineCode: "EI",
    AirlineName: "Aer Lingus",
  },
  {
    AirlineCode: "EJ",
    AirlineName: "New England Airlines",
  },
  {
    AirlineCode: "EK",
    AirlineName: "Emirates Airline",
  },
  {
    AirlineCode: "EL",
    AirlineName: "Ellin Air",
  },
  {
    AirlineCode: "EM",
    AirlineName: "Empire Airlines",
  },
  {
    AirlineCode: "EN",
    AirlineName: "Air Dolomiti",
  },
  {
    AirlineCode: "EO",
    AirlineName: "Pegas Fly",
  },
  {
    AirlineCode: "EP",
    AirlineName: "Iran Aseman",
  },
  {
    AirlineCode: "EQ",
    AirlineName: "TAME",
  },
  {
    AirlineCode: "ER",
    AirlineName: "Astar Air Cargo",
  },
  {
    AirlineCode: "ES",
    AirlineName: "DHL International",
  },
  {
    AirlineCode: "ET",
    AirlineName: "Ethiopian Airlines",
  },
  {
    AirlineCode: "EU",
    AirlineName: "Empresa Ecuatoriana De Aviación",
  },
  {
    AirlineCode: "EV",
    AirlineName: "Aha",
  },
  {
    AirlineCode: "EW",
    AirlineName: "Eurowings",
  },
  {
    AirlineCode: "EX",
    AirlineName: "Atlantic Airlines",
  },
  {
    AirlineCode: "EY",
    AirlineName: "Etihad Airways",
  },
  {
    AirlineCode: "EZ",
    AirlineName: "Sun Air of Scandinavia",
  },
  {
    AirlineCode: "F2",
    AirlineName: "SAFARILINK AVIATION",
  },
  {
    AirlineCode: "F3",
    AirlineName: "Flyadeal",
  },
  {
    AirlineCode: "F4",
    AirlineName: "Albarka Air",
  },
  {
    AirlineCode: "F5",
    AirlineName: "Cosmic Air",
  },
  {
    AirlineCode: "F6",
    AirlineName: "Faroejet",
  },
  {
    AirlineCode: "F7",
    AirlineName: "Flybaboo",
  },
  {
    AirlineCode: "F8",
    AirlineName: "Flair Airlines",
  },
  {
    AirlineCode: "F9",
    AirlineName: "Frontier Airlines",
  },
  {
    AirlineCode: "FA",
    AirlineName: "Safair",
  },
  {
    AirlineCode: "FB",
    AirlineName: "Bulgaria Air",
  },
  {
    AirlineCode: "FC",
    AirlineName: "Viva Colombia",
  },
  {
    AirlineCode: "FD",
    AirlineName: "Thai AirAsia",
  },
  {
    AirlineCode: "FE",
    AirlineName: "Primaris Airlines",
  },
  {
    AirlineCode: "FF",
    AirlineName: "Airshop",
  },
  {
    AirlineCode: "FG",
    AirlineName: "Ariana Afghan Airlines",
  },
  {
    AirlineCode: "FH",
    AirlineName: "Freebird Airlines",
  },
  {
    AirlineCode: "FI",
    AirlineName: "Icelandair",
  },
  {
    AirlineCode: "FJ",
    AirlineName: "Air Pacific",
  },
  {
    AirlineCode: "FK",
    AirlineName: "Africa West",
  },
  {
    AirlineCode: "FL",
    AirlineName: "AirTran Airways",
  },
  {
    AirlineCode: "FM",
    AirlineName: "Shanghai Airlines",
  },
  {
    AirlineCode: "FN",
    AirlineName: "Regional Air Lines",
  },
  {
    AirlineCode: "FO",
    AirlineName: "Flybondi",
  },
  {
    AirlineCode: "FP",
    AirlineName: "Fly Pelican",
  },
  {
    AirlineCode: "FP0",
    AirlineName: "Fly Persia",
  },
  {
    AirlineCode: "FPI",
    AirlineName: "FPI",
  },
  {
    AirlineCode: "FR",
    AirlineName: "Ryanair",
  },
  {
    AirlineCode: "FS",
    AirlineName: "Syphax Airlines",
  },
  {
    AirlineCode: "FT",
    AirlineName: "FlyEgypt",
  },
  {
    AirlineCode: "FU",
    AirlineName: "Fuzhou Airlines",
  },
  {
    AirlineCode: "FV",
    AirlineName: "Rossiya",
  },
  {
    AirlineCode: "FW",
    AirlineName: "Ibex Airlines",
  },
  {
    AirlineCode: "FX",
    AirlineName: "Federal Express",
  },
  {
    AirlineCode: "FY",
    AirlineName: "Firefly",
  },
  {
    AirlineCode: "FZ",
    AirlineName: "Fly Dubai",
  },
  {
    AirlineCode: "G0",
    AirlineName: "Ghana International Airlines",
  },
  {
    AirlineCode: "G1",
    AirlineName: "Gorkha Airlines",
  },
  {
    AirlineCode: "G2",
    AirlineName: "Avirex",
  },
  {
    AirlineCode: "G3",
    AirlineName: "Gol Linhas Aereas",
  },
  {
    AirlineCode: "G4",
    AirlineName: "Allegiant Air",
  },
  {
    AirlineCode: "G5",
    AirlineName: "China Express Airlines",
  },
  {
    AirlineCode: "G6",
    AirlineName: "Fly Arna",
  },
  {
    AirlineCode: "G7",
    AirlineName: "GoJet Airlines",
  },
  {
    AirlineCode: "G8",
    AirlineName: "Go Airlines",
  },
  {
    AirlineCode: "G9",
    AirlineName: "Air Arabia",
  },
  {
    AirlineCode: "GA",
    AirlineName: "Garuda Indonesia",
  },
  {
    AirlineCode: "GB",
    AirlineName: "Airborne Express",
  },
  {
    AirlineCode: "GC",
    AirlineName: "Gambia International Airlines",
  },
  {
    AirlineCode: "GD",
    AirlineName: "Aviair",
  },
  {
    AirlineCode: "GE",
    AirlineName: "TransAsia Airways",
  },
  {
    AirlineCode: "GF",
    AirlineName: "Gulf Air",
  },
  {
    AirlineCode: "GG",
    AirlineName: "Air Guyane",
  },
  {
    AirlineCode: "GH",
    AirlineName: "Ghana Airways",
  },
  {
    AirlineCode: "GI",
    AirlineName: "Itek Air",
  },
  {
    AirlineCode: "GJ",
    AirlineName: "Zhejiang Loong Airlines",
  },
  {
    AirlineCode: "GK",
    AirlineName: "JetStar Japan",
  },
  {
    AirlineCode: "GL",
    AirlineName: "Air Greenland",
  },
  {
    AirlineCode: "GM",
    AirlineName: "Air Slovakia",
  },
  {
    AirlineCode: "GN",
    AirlineName: "Air Gabon",
  },
  {
    AirlineCode: "GO",
    AirlineName: "Kuzu Airlines Cargo",
  },
  {
    AirlineCode: "GP",
    AirlineName: "APG Airlines",
  },
  {
    AirlineCode: "GQ",
    AirlineName: "Sky Express",
  },
  {
    AirlineCode: "GR",
    AirlineName: "Aurigny Air Services",
  },
  {
    AirlineCode: "GS",
    AirlineName: "Tianjin Airlines",
  },
  {
    AirlineCode: "GT",
    AirlineName: "GB Airways",
  },
  {
    AirlineCode: "GV",
    AirlineName: "Grant Aviation",
  },
  {
    AirlineCode: "GW",
    AirlineName: "Costa Rica Green Airways",
  },
  {
    AirlineCode: "GX",
    AirlineName: "Guangxi Beibu Gulf Airlines",
  },
  {
    AirlineCode: "GY",
    AirlineName: "Colorful Guizhou Airline",
  },
  {
    AirlineCode: "GZ",
    AirlineName: "Air Rarotonga",
  },
  {
    AirlineCode: "H1",
    AirlineName: "Hahn Air Systems",
  },
  {
    AirlineCode: "H2",
    AirlineName: "Sky Airline",
  },
  {
    AirlineCode: "H3",
    AirlineName: "H3",
  },
  {
    AirlineCode: "H4",
    AirlineName: "Aero4M",
  },
  {
    AirlineCode: "H5",
    AirlineName: "Haiti Aviation",
  },
  {
    AirlineCode: "H6",
    AirlineName: "Bulgarian Air Charter",
  },
  {
    AirlineCode: "H7",
    AirlineName: "Eagle Air",
  },
  {
    AirlineCode: "H8",
    AirlineName: "Dalavia",
  },
  {
    AirlineCode: "H9",
    AirlineName: "Himalaya Airlines",
  },
  {
    AirlineCode: "HA",
    AirlineName: "Hawaiian Airlines",
  },
  {
    AirlineCode: "HB",
    AirlineName: "Harbor Airlines",
  },
  {
    AirlineCode: "HC",
    AirlineName: "Air Senegal",
  },
  {
    AirlineCode: "HD",
    AirlineName: "AIRDO",
  },
  {
    AirlineCode: "HE",
    AirlineName: "Luftfahrtgesellschaft Walter",
  },
  {
    AirlineCode: "HF",
    AirlineName: "Hapagfly",
  },
  {
    AirlineCode: "HG",
    AirlineName: "Niki",
  },
  {
    AirlineCode: "HI",
    AirlineName: "Papillon Airways",
  },
  {
    AirlineCode: "HJ",
    AirlineName: "Hellas Jet",
  },
  {
    AirlineCode: "HK",
    AirlineName: "Four Star Aviation / Four Star Cargo",
  },
  {
    AirlineCode: "HM",
    AirlineName: "Air Seychelles",
  },
  {
    AirlineCode: "HN",
    AirlineName: "Heavylift Cargo Airlines",
  },
  {
    AirlineCode: "HO",
    AirlineName: "Juneyao Airlines",
  },
  {
    AirlineCode: "HP",
    AirlineName: "Amapola Flyg",
  },
  {
    AirlineCode: "HQ",
    AirlineName: "Thomas Cook Airlines",
  },
  {
    AirlineCode: "HR",
    AirlineName: "Hahn Air",
  },
  {
    AirlineCode: "HS",
    AirlineName: "Heli Securite Helicopter Airline",
  },
  {
    AirlineCode: "HT",
    AirlineName: "Aeromist-Kharkiv",
  },
  {
    AirlineCode: "HU",
    AirlineName: "Hainan Airlines",
  },
  {
    AirlineCode: "HV",
    AirlineName: "Transavia Holland",
  },
  {
    AirlineCode: "HW",
    AirlineName: "Fly Erbil",
  },
  {
    AirlineCode: "HX",
    AirlineName: "Hong Kong Airlines",
  },
  {
    AirlineCode: "HY",
    AirlineName: "Uzbekistan Airways",
  },
  {
    AirlineCode: "HZ",
    AirlineName: "Aurora Airlines",
  },
  {
    AirlineCode: "I2",
    AirlineName: "Iberia Express",
  },
  {
    AirlineCode: "I3",
    AirlineName: "ATA",
  },
  {
    AirlineCode: "I4",
    AirlineName: "Interstate Airlines",
  },
  {
    AirlineCode: "I5",
    AirlineName: "AirAsia India",
  },
  {
    AirlineCode: "I6",
    AirlineName: "Sky Eyes",
  },
  {
    AirlineCode: "I7",
    AirlineName: "Paramount Airways",
  },
  {
    AirlineCode: "I8",
    AirlineName: "Izhavia",
  },
  {
    AirlineCode: "I9",
    AirlineName: "Air Italy",
  },
  {
    AirlineCode: "IA",
    AirlineName: "Iraqi Airways",
  },
  {
    AirlineCode: "IB",
    AirlineName: "Iberia Airlines",
  },
  {
    AirlineCode: "IC",
    AirlineName: "Indian Airlines",
  },
  {
    AirlineCode: "ID",
    AirlineName: "Interlink Airlines",
  },
  {
    AirlineCode: "IE",
    AirlineName: "Solomon Airlines",
  },
  {
    AirlineCode: "IF",
    AirlineName: "Fly Baghdad",
  },
  {
    AirlineCode: "IG",
    AirlineName: "Air Italy",
  },
  {
    AirlineCode: "IH",
    AirlineName: "Irtysh Air",
  },
  {
    AirlineCode: "II",
    AirlineName: "IBC Airways",
  },
  {
    AirlineCode: "IJ",
    AirlineName: "Spring Airlines Japan",
  },
  {
    AirlineCode: "IK",
    AirlineName: "Ikar",
  },
  {
    AirlineCode: "IM",
    AirlineName: "Menajet",
  },
  {
    AirlineCode: "IN",
    AirlineName: "MAT Macedonian Airlines",
  },
  {
    AirlineCode: "IO",
    AirlineName: "IrAero",
  },
  {
    AirlineCode: "IP",
    AirlineName: "Atyrau Air Ways",
  },
  {
    AirlineCode: "IQ",
    AirlineName: "Augsburg Airways",
  },
  {
    AirlineCode: "IR",
    AirlineName: "Iran Air",
  },
  {
    AirlineCode: "IRA",
    AirlineName: "IRA",
  },
  {
    AirlineCode: "IRC",
    AirlineName: "IRC",
  },
  {
    AirlineCode: "IRK",
    AirlineName: "IRK",
  },
  {
    AirlineCode: "IRM",
    AirlineName: "IRM",
  },
  {
    AirlineCode: "IRQ",
    AirlineName: "IRQ",
  },
  {
    AirlineCode: "IRU",
    AirlineName: "Chabahar Airlines",
  },
  {
    AirlineCode: "IRZ",
    AirlineName: "Saha",
  },
  {
    AirlineCode: "IS",
    AirlineName: "AIS Airlines",
  },
  {
    AirlineCode: "IT",
    AirlineName: "Tigerair Taiwan",
  },
  {
    AirlineCode: "IU",
    AirlineName: "Super Air Jet",
  },
  {
    AirlineCode: "IW",
    AirlineName: "AOM French Airlines",
  },
  {
    AirlineCode: "IX",
    AirlineName: "Air India Express",
  },
  {
    AirlineCode: "IY",
    AirlineName: "Yemenia",
  },
  {
    AirlineCode: "IZ",
    AirlineName: "Arkia Israel Airlines",
  },
  {
    AirlineCode: "IZG",
    AirlineName: "IZG",
  },
  {
    AirlineCode: "J2",
    AirlineName: "Azerbaijan Airlines",
  },
  {
    AirlineCode: "J3",
    AirlineName: "Northwestern Air",
  },
  {
    AirlineCode: "J4",
    AirlineName: "Badr Airlines",
  },
  {
    AirlineCode: "J6",
    AirlineName: "AVCOM",
  },
  {
    AirlineCode: "J7",
    AirlineName: "Denim Air",
  },
  {
    AirlineCode: "J8",
    AirlineName: "Berjaya Air",
  },
  {
    AirlineCode: "J9",
    AirlineName: "Jazeera Airways",
  },
  {
    AirlineCode: "JA",
    AirlineName: "B&H Airlines",
  },
  {
    AirlineCode: "JB",
    AirlineName: "Helijet",
  },
  {
    AirlineCode: "JC",
    AirlineName: "JAL Express",
  },
  {
    AirlineCode: "JD",
    AirlineName: "Beijing Airlines",
  },
  {
    AirlineCode: "JE",
    AirlineName: "Mango",
  },
  {
    AirlineCode: "JF",
    AirlineName: "Jet Asia Airways",
  },
  {
    AirlineCode: "JG",
    AirlineName: "Airline Container Leasing",
  },
  {
    AirlineCode: "JH",
    AirlineName: "Nordeste Linhas Aéreas Regionais",
  },
  {
    AirlineCode: "JI",
    AirlineName: "Meraj Air",
  },
  {
    AirlineCode: "JJ",
    AirlineName: "Latam Airlines Brasil",
  },
  {
    AirlineCode: "JK",
    AirlineName: "Spanair",
  },
  {
    AirlineCode: "JL",
    AirlineName: "Japan Airlines",
  },
  {
    AirlineCode: "JM",
    AirlineName: "Air Jamaica",
  },
  {
    AirlineCode: "JN",
    AirlineName: "JOON",
  },
  {
    AirlineCode: "JO",
    AirlineName: "Jet time",
  },
  {
    AirlineCode: "JP",
    AirlineName: "Adria Airways",
  },
  {
    AirlineCode: "JQ",
    AirlineName: "Jetstar Airways",
  },
  {
    AirlineCode: "JR",
    AirlineName: "Aero California",
  },
  {
    AirlineCode: "JS",
    AirlineName: "Air Koryo",
  },
  {
    AirlineCode: "JT",
    AirlineName: "Lion Mentari Airlines",
  },
  {
    AirlineCode: "JU",
    AirlineName: "Air Serbia",
  },
  {
    AirlineCode: "JV",
    AirlineName: "Bearskin Lake Air Service",
  },
  {
    AirlineCode: "JW",
    AirlineName: "Vanilla Air",
  },
  {
    AirlineCode: "JX",
    AirlineName: "Starlux Airlines",
  },
  {
    AirlineCode: "JY",
    AirlineName: "Intercaribbean Airways",
  },
  {
    AirlineCode: "JZ",
    AirlineName: "Jatayu Gelang Sejahtera",
  },
  {
    AirlineCode: "K-",
    AirlineName: "K-",
  },
  {
    AirlineCode: "K2",
    AirlineName: "Eurolot",
  },
  {
    AirlineCode: "K4",
    AirlineName: "Kalitta Air",
  },
  {
    AirlineCode: "K5",
    AirlineName: "SeaPort Airlines",
  },
  {
    AirlineCode: "K6",
    AirlineName: "Cambodia Angkor Air",
  },
  {
    AirlineCode: "K7",
    AirlineName: "Air KBZ",
  },
  {
    AirlineCode: "K8",
    AirlineName: "Airlink Zambia",
  },
  {
    AirlineCode: "K9",
    AirlineName: "Krylo Airlines",
  },
  {
    AirlineCode: "KA",
    AirlineName: "Dragonair, Hong Kong Dragon Airlines",
  },
  {
    AirlineCode: "KB",
    AirlineName: "Druk Air",
  },
  {
    AirlineCode: "KC",
    AirlineName: "Air Astana",
  },
  {
    AirlineCode: "KD",
    AirlineName: "PT KAL Star Aviation",
  },
  {
    AirlineCode: "KE",
    AirlineName: "Korean Air",
  },
  {
    AirlineCode: "KF",
    AirlineName: "Blue1",
  },
  {
    AirlineCode: "KG",
    AirlineName: "LAI - Línea Aérea IAACA",
  },
  {
    AirlineCode: "KH",
    AirlineName: "Aloha Air Cargo",
  },
  {
    AirlineCode: "KI",
    AirlineName: "SKS Airways",
  },
  {
    AirlineCode: "KIA",
    AirlineName: "KIA",
  },
  {
    AirlineCode: "KIS",
    AirlineName: "Kish Air",
  },
  {
    AirlineCode: "KJ",
    AirlineName: "Air Incheon",
  },
  {
    AirlineCode: "KK",
    AirlineName: "Atlas Global",
  },
  {
    AirlineCode: "KL",
    AirlineName: "KLM",
  },
  {
    AirlineCode: "KM",
    AirlineName: "Air Malta",
  },
  {
    AirlineCode: "KN",
    AirlineName: "China United Airlines",
  },
  {
    AirlineCode: "KO",
    AirlineName: "Alaska Central Express",
  },
  {
    AirlineCode: "KP",
    AirlineName: "ASKY Airlines",
  },
  {
    AirlineCode: "KQ",
    AirlineName: "Kenya Airways",
  },
  {
    AirlineCode: "KR",
    AirlineName: "Cambodia Airways",
  },
  {
    AirlineCode: "KS",
    AirlineName: "Air Connect",
  },
  {
    AirlineCode: "KU",
    AirlineName: "Kuwait Airways",
  },
  {
    AirlineCode: "KV",
    AirlineName: "Asian Express Airlines",
  },
  {
    AirlineCode: "KW",
    AirlineName: "Kharkiv Airlines",
  },
  {
    AirlineCode: "KX",
    AirlineName: "Cayman Airways",
  },
  {
    AirlineCode: "KY",
    AirlineName: "Air São Tomé and Príncipe",
  },
  {
    AirlineCode: "KZ",
    AirlineName: "Nippon Cargo Airlines",
  },
  {
    AirlineCode: "L1",
    AirlineName: "Lufthansa Systems",
  },
  {
    AirlineCode: "L2",
    AirlineName: "Lynden Air Cargo",
  },
  {
    AirlineCode: "L3",
    AirlineName: "Lynx Aviation",
  },
  {
    AirlineCode: "L4",
    AirlineName: "Air Service",
  },
  {
    AirlineCode: "L5",
    AirlineName: "Atlantique Air Assistance",
  },
  {
    AirlineCode: "L6",
    AirlineName: "Tbilaviamsheni",
  },
  {
    AirlineCode: "L8",
    AirlineName: "Air Luxor GB",
  },
  {
    AirlineCode: "L9",
    AirlineName: "Lumiwings",
  },
  {
    AirlineCode: "LA",
    AirlineName: "Latam Airlines Group",
  },
  {
    AirlineCode: "LB",
    AirlineName: "Lloyd Aéreo Boliviano",
  },
  {
    AirlineCode: "LC",
    AirlineName: "Equatorial Congo Airline",
  },
  {
    AirlineCode: "LD",
    AirlineName: "Air Hong Kong",
  },
  {
    AirlineCode: "LE",
    AirlineName: "LE",
  },
  {
    AirlineCode: "LF",
    AirlineName: "FlyNordic",
  },
  {
    AirlineCode: "LG",
    AirlineName: "Luxair",
  },
  {
    AirlineCode: "LH",
    AirlineName: "Lufthansa",
  },
  {
    AirlineCode: "LI",
    AirlineName: "Leeward Islands Air Transport",
  },
  {
    AirlineCode: "LJ",
    AirlineName: "Sierra National Airlines",
  },
  {
    AirlineCode: "LK",
    AirlineName: "Kyrgyz Airlines",
  },
  {
    AirlineCode: "LL",
    AirlineName: "Miami Air International",
  },
  {
    AirlineCode: "LM",
    AirlineName: "Loganair",
  },
  {
    AirlineCode: "LN",
    AirlineName: "Libyan Arab Airlines",
  },
  {
    AirlineCode: "LO",
    AirlineName: "LOT Polish Airlines",
  },
  {
    AirlineCode: "LP",
    AirlineName: "LAN Peru",
  },
  {
    AirlineCode: "LQ",
    AirlineName: "Lanmei Airlines",
  },
  {
    AirlineCode: "LR",
    AirlineName: "LACSA",
  },
  {
    AirlineCode: "LS",
    AirlineName: "Jet2.com",
  },
  {
    AirlineCode: "LT",
    AirlineName: "Air Lituanica",
  },
  {
    AirlineCode: "LU",
    AirlineName: "Latam Airlines Chile",
  },
  {
    AirlineCode: "LV",
    AirlineName: "Albanian Airlines",
  },
  {
    AirlineCode: "LW",
    AirlineName: "Pacific Wings",
  },
  {
    AirlineCode: "LX",
    AirlineName: "Swiss International Air Lines",
  },
  {
    AirlineCode: "LY",
    AirlineName: "El Al Israel Airlines",
  },
  {
    AirlineCode: "LZ",
    AirlineName: "Air Link",
  },
  {
    AirlineCode: "M0",
    AirlineName: "Aero Mongolia",
  },
  {
    AirlineCode: "M2",
    AirlineName: "Mahfooz Aviation",
  },
  {
    AirlineCode: "M3",
    AirlineName: "North Flying",
  },
  {
    AirlineCode: "M4",
    AirlineName: "Mistral Air",
  },
  {
    AirlineCode: "M5",
    AirlineName: "Kenmore Air",
  },
  {
    AirlineCode: "M6",
    AirlineName: "Amerijet International",
  },
  {
    AirlineCode: "M7",
    AirlineName: "MasAir",
  },
  {
    AirlineCode: "M8",
    AirlineName: "Mekong Airlines",
  },
  {
    AirlineCode: "M9",
    AirlineName: "Motor Sich",
  },
  {
    AirlineCode: "MA",
    AirlineName: "Malév Hungarian Airlines",
  },
  {
    AirlineCode: "MB",
    AirlineName: "MNG Airlines",
  },
  {
    AirlineCode: "MC",
    AirlineName: "Air Mobility Command",
  },
  {
    AirlineCode: "MD",
    AirlineName: "Air Madagascar",
  },
  {
    AirlineCode: "ME",
    AirlineName: "Middle East Airlines",
  },
  {
    AirlineCode: "MF",
    AirlineName: "Xiamen Airlines",
  },
  {
    AirlineCode: "MG",
    AirlineName: "Champion Air",
  },
  {
    AirlineCode: "MGH",
    AirlineName: "MGH",
  },
  {
    AirlineCode: "MH",
    AirlineName: "Malaysia Airlines",
  },
  {
    AirlineCode: "MI",
    AirlineName: "SilkAir",
  },
  {
    AirlineCode: "MJ",
    AirlineName: "Myway Airlines",
  },
  {
    AirlineCode: "MK",
    AirlineName: "Air Mauritius",
  },
  {
    AirlineCode: "ML",
    AirlineName: "Air Mediterranee",
  },
  {
    AirlineCode: "MM",
    AirlineName: "Peach Aviation",
  },
  {
    AirlineCode: "MN",
    AirlineName: "Kulula",
  },
  {
    AirlineCode: "MO",
    AirlineName: "Calm Air",
  },
  {
    AirlineCode: "MP",
    AirlineName: "Martinair",
  },
  {
    AirlineCode: "MQ",
    AirlineName: "American Eagle Airlines",
  },
  {
    AirlineCode: "MR",
    AirlineName: "Air Mauritanie",
  },
  {
    AirlineCode: "MS",
    AirlineName: "Egyptair",
  },
  {
    AirlineCode: "MT",
    AirlineName: "Thomas Cook Airlines",
  },
  {
    AirlineCode: "MTDE",
    AirlineName: "Thomas Cook Airlines",
  },
  {
    AirlineCode: "MU",
    AirlineName: "China Eastern Airlines",
  },
  {
    AirlineCode: "MV",
    AirlineName: "Armenian International Airways",
  },
  {
    AirlineCode: "MW",
    AirlineName: "Mokulele Airlines",
  },
  {
    AirlineCode: "MX",
    AirlineName: "Breeze Airways",
  },
  {
    AirlineCode: "MY",
    AirlineName: "Maya Island Air",
  },
  {
    AirlineCode: "MZ",
    AirlineName: "Amakusa Airlines",
  },
  {
    AirlineCode: "N0",
    AirlineName: "Norse Atlantic Airways",
  },
  {
    AirlineCode: "N2",
    AirlineName: "Kabo Air",
  },
  {
    AirlineCode: "N3",
    AirlineName: "Omskavia Airline",
  },
  {
    AirlineCode: "N4",
    AirlineName: "Nord Wind",
  },
  {
    AirlineCode: "N5",
    AirlineName: "Norfolk Air",
  },
  {
    AirlineCode: "N6",
    AirlineName: "Nomad Aviation",
  },
  {
    AirlineCode: "N7",
    AirlineName: "National Airlines",
  },
  {
    AirlineCode: "N8",
    AirlineName: "National Airlines",
  },
  {
    AirlineCode: "N9",
    AirlineName: "Novair",
  },
  {
    AirlineCode: "NA",
    AirlineName: "North American Airlines",
  },
  {
    AirlineCode: "NB",
    AirlineName: "Sterling Airlines",
  },
  {
    AirlineCode: "NC",
    AirlineName: "National Jet Systems",
  },
  {
    AirlineCode: "ND",
    AirlineName: "FMI Air",
  },
  {
    AirlineCode: "NE",
    AirlineName: "SkyEurope",
  },
  {
    AirlineCode: "NF",
    AirlineName: "Air Vanuatu",
  },
  {
    AirlineCode: "NG",
    AirlineName: "Lauda Air",
  },
  {
    AirlineCode: "NH",
    AirlineName: "All Nippon Airways",
  },
  {
    AirlineCode: "NI",
    AirlineName: "Portugalia",
  },
  {
    AirlineCode: "NK",
    AirlineName: "Spirit Airlines",
  },
  {
    AirlineCode: "NL",
    AirlineName: "Shaheen Air International",
  },
  {
    AirlineCode: "NM",
    AirlineName: "Air Madrid",
  },
  {
    AirlineCode: "NN",
    AirlineName: "VIM Airlines",
  },
  {
    AirlineCode: "NO",
    AirlineName: "Neos",
  },
  {
    AirlineCode: "NP",
    AirlineName: "Nile Air",
  },
  {
    AirlineCode: "NPO",
    AirlineName: "NPO",
  },
  {
    AirlineCode: "NQ",
    AirlineName: "Air Japan",
  },
  {
    AirlineCode: "NR",
    AirlineName: "Pamir Airways",
  },
  {
    AirlineCode: "NS",
    AirlineName: "Hebei Airlines",
  },
  {
    AirlineCode: "NT",
    AirlineName: "Binter Canarias",
  },
  {
    AirlineCode: "NU",
    AirlineName: "Japan Transocean Air",
  },
  {
    AirlineCode: "NV",
    AirlineName: "Karun Airline",
  },
  {
    AirlineCode: "NW",
    AirlineName: "Northwest Airlines",
  },
  {
    AirlineCode: "NX",
    AirlineName: "Air Macau",
  },
  {
    AirlineCode: "NY",
    AirlineName: "Air Iceland",
  },
  {
    AirlineCode: "NZ",
    AirlineName: "Air New Zealand",
  },
  {
    AirlineCode: "O2",
    AirlineName: "Oceanic Airlines",
  },
  {
    AirlineCode: "O4",
    AirlineName: "Antrak Air",
  },
  {
    AirlineCode: "O6",
    AirlineName: "Avianca Brazil",
  },
  {
    AirlineCode: "O7",
    AirlineName: "Ozjet Airlines",
  },
  {
    AirlineCode: "O8",
    AirlineName: "Oasis Hong Kong Airlines",
  },
  {
    AirlineCode: "O9",
    AirlineName: "Nova Airline",
  },
  {
    AirlineCode: "OA",
    AirlineName: "Olympic Air",
  },
  {
    AirlineCode: "OB",
    AirlineName: "Boliviana De Aviacion",
  },
  {
    AirlineCode: "OC",
    AirlineName: "Oriental Air Bridge",
  },
  {
    AirlineCode: "OD",
    AirlineName: "Malindo Airways",
  },
  {
    AirlineCode: "OE",
    AirlineName: "Laudamotion",
  },
  {
    AirlineCode: "OF",
    AirlineName: "Air Finland",
  },
  {
    AirlineCode: "OG",
    AirlineName: "Play",
  },
  {
    AirlineCode: "OH",
    AirlineName: "PSA Airlines",
  },
  {
    AirlineCode: "OIFE",
    AirlineName: "Hesa",
  },
  {
    AirlineCode: "OJ",
    AirlineName: "Fly Jamaica Airways",
  },
  {
    AirlineCode: "OK",
    AirlineName: "Czech Airlines",
  },
  {
    AirlineCode: "OL",
    AirlineName: "OLT Express Germany",
  },
  {
    AirlineCode: "OM",
    AirlineName: "MIAT Mongolian Airlines",
  },
  {
    AirlineCode: "ON",
    AirlineName: "Our Airline",
  },
  {
    AirlineCode: "OO",
    AirlineName: "SkyWest Airlines",
  },
  {
    AirlineCode: "OP",
    AirlineName: "Chalk's International Airlines",
  },
  {
    AirlineCode: "OQ",
    AirlineName: "Chongqing Airlines",
  },
  {
    AirlineCode: "OR",
    AirlineName: "Arkefly",
  },
  {
    AirlineCode: "OS",
    AirlineName: "Austrian Airlines",
  },
  {
    AirlineCode: "OT",
    AirlineName: "Aeropelican Air Services",
  },
  {
    AirlineCode: "OU",
    AirlineName: "Croatia Airlines",
  },
  {
    AirlineCode: "OV",
    AirlineName: "Salam Air",
  },
  {
    AirlineCode: "OW",
    AirlineName: "Skyward Eepress",
  },
  {
    AirlineCode: "OX",
    AirlineName: "Orient Thai Airlines",
  },
  {
    AirlineCode: "OY",
    AirlineName: "Andes Líneas Aéreas",
  },
  {
    AirlineCode: "OZ",
    AirlineName: "Asiana Airlines",
  },
  {
    AirlineCode: "P0",
    AirlineName: "Proflight Zambia",
  },
  {
    AirlineCode: "P1",
    AirlineName: "PublicCharters.com",
  },
  {
    AirlineCode: "P2",
    AirlineName: "AirKenya Express",
  },
  {
    AirlineCode: "P3",
    AirlineName: "Passaredo Transportes Aéreos",
  },
  {
    AirlineCode: "P4",
    AirlineName: "Air Peace",
  },
  {
    AirlineCode: "P5",
    AirlineName: "Wingo",
  },
  {
    AirlineCode: "P6",
    AirlineName: "Pascan",
  },
  {
    AirlineCode: "P7",
    AirlineName: "Russian Sky Airlines",
  },
  {
    AirlineCode: "P8",
    AirlineName: "Air Mekong",
  },
  {
    AirlineCode: "P9",
    AirlineName: "Peruvian Airlines",
  },
  {
    AirlineCode: "PA",
    AirlineName: "Airblue",
  },
  {
    AirlineCode: "PB",
    AirlineName: "PAL Airlines",
  },
  {
    AirlineCode: "PC",
    AirlineName: "Pegasus Airlines",
  },
  {
    AirlineCode: "PD",
    AirlineName: "Porter Airlines",
  },
  {
    AirlineCode: "PE",
    AirlineName: "People's",
  },
  {
    AirlineCode: "PF",
    AirlineName: "Primera Air Scandinavia ",
  },
  {
    AirlineCode: "PG",
    AirlineName: "Bangkok Airways",
  },
  {
    AirlineCode: "PH",
    AirlineName: "Polynesian Airlines",
  },
  {
    AirlineCode: "PI",
    AirlineName: "Polar Airlines",
  },
  {
    AirlineCode: "PJ",
    AirlineName: "Air Saint Pierre",
  },
  {
    AirlineCode: "PK",
    AirlineName: "Pakistan International Airlines",
  },
  {
    AirlineCode: "PL",
    AirlineName: "Southern Air Charter",
  },
  {
    AirlineCode: "PM",
    AirlineName: "Tropic Air",
  },
  {
    AirlineCode: "PN",
    AirlineName: "China West Air",
  },
  {
    AirlineCode: "PO",
    AirlineName: "Polar Air Cargo",
  },
  {
    AirlineCode: "PP",
    AirlineName: "Jet Aviation",
  },
  {
    AirlineCode: "PQ",
    AirlineName: "Sky up",
  },
  {
    AirlineCode: "PR",
    AirlineName: "Philippine Airlines",
  },
  {
    AirlineCode: "PRS",
    AirlineName: "Pars Air",
  },
  {
    AirlineCode: "PS",
    AirlineName: "Ukraine International",
  },
  {
    AirlineCode: "PT",
    AirlineName: "Piedmont Airlines",
  },
  {
    AirlineCode: "PU",
    AirlineName: "PLUNA",
  },
  {
    AirlineCode: "PV",
    AirlineName: "St Barth Commuter",
  },
  {
    AirlineCode: "PW",
    AirlineName: "Precision Air",
  },
  {
    AirlineCode: "PX",
    AirlineName: "Air Niugini",
  },
  {
    AirlineCode: "PY",
    AirlineName: "Surinam Airways",
  },
  {
    AirlineCode: "PYA",
    AirlineName: "Pouya Air",
  },
  {
    AirlineCode: "PZ",
    AirlineName: "Latam Airlines Paraguay",
  },
  {
    AirlineCode: "Q3",
    AirlineName: "Zambian Airways",
  },
  {
    AirlineCode: "Q4",
    AirlineName: "Euro Airlines",
  },
  {
    AirlineCode: "Q5",
    AirlineName: "40-Mile Air",
  },
  {
    AirlineCode: "Q6",
    AirlineName: "Aero Condor Peru",
  },
  {
    AirlineCode: "Q8",
    AirlineName: "Pacific East Asia Cargo Airlines",
  },
  {
    AirlineCode: "Q9",
    AirlineName: "Green Africa Airways",
  },
  {
    AirlineCode: "QA",
    AirlineName: "Cimber Sterling",
  },
  {
    AirlineCode: "QB",
    AirlineName: "Qeshm Air",
  },
  {
    AirlineCode: "QB2",
    AirlineName: "QB2",
  },
  {
    AirlineCode: "QC",
    AirlineName: "Air Corridor",
  },
  {
    AirlineCode: "QD",
    AirlineName: "JC Cambodia Intl Airlines",
  },
  {
    AirlineCode: "QE",
    AirlineName: "Crossair Europe",
  },
  {
    AirlineCode: "QF",
    AirlineName: "Qantas",
  },
  {
    AirlineCode: "QG",
    AirlineName: "Citilink Indonesia",
  },
  {
    AirlineCode: "QH",
    AirlineName: "Bamboo Airways",
  },
  {
    AirlineCode: "QI",
    AirlineName: "Cimber Sterling",
  },
  {
    AirlineCode: "QJ",
    AirlineName: "Jet Airways",
  },
  {
    AirlineCode: "QK",
    AirlineName: "Air Canada Jazz",
  },
  {
    AirlineCode: "QL",
    AirlineName: "Línea Aérea de Servicio ",
  },
  {
    AirlineCode: "QM",
    AirlineName: "Air Malawi",
  },
  {
    AirlineCode: "QN",
    AirlineName: "Skytrans Regional",
  },
  {
    AirlineCode: "QO",
    AirlineName: "Aeromexpress",
  },
  {
    AirlineCode: "QQ",
    AirlineName: "Alliance Airlines",
  },
  {
    AirlineCode: "QR",
    AirlineName: "Qatar Airways",
  },
  {
    AirlineCode: "QS",
    AirlineName: "Smartwings",
  },
  {
    AirlineCode: "QT",
    AirlineName: "TAMPA",
  },
  {
    AirlineCode: "QU",
    AirlineName: "UTair-Ukraine",
  },
  {
    AirlineCode: "QV",
    AirlineName: "Lao Airlines",
  },
  {
    AirlineCode: "QW",
    AirlineName: "Blue Wings",
  },
  {
    AirlineCode: "QX",
    AirlineName: "Horizon Air",
  },
  {
    AirlineCode: "QY",
    AirlineName: "European Air Transport",
  },
  {
    AirlineCode: "QZ",
    AirlineName: "PT Indonesia AirAsia",
  },
  {
    AirlineCode: "R0",
    AirlineName: "Royal Airlines",
  },
  {
    AirlineCode: "R1",
    AirlineName: "Sirin",
  },
  {
    AirlineCode: "R2",
    AirlineName: "Orenburg Airlines",
  },
  {
    AirlineCode: "R3",
    AirlineName: "Aircompany Yakutia",
  },
  {
    AirlineCode: "R5",
    AirlineName: "Jordan Aviation",
  },
  {
    AirlineCode: "R6",
    AirlineName: "RACSA",
  },
  {
    AirlineCode: "R7",
    AirlineName: "Aserca Airlines",
  },
  {
    AirlineCode: "R8",
    AirlineName: "Kyrgyzstan Airlines",
  },
  {
    AirlineCode: "R9",
    AirlineName: "Camai Air",
  },
  {
    AirlineCode: "RA",
    AirlineName: "Nepal Airlines",
  },
  {
    AirlineCode: "RB",
    AirlineName: "Syrian Arab Airlines",
  },
  {
    AirlineCode: "RC",
    AirlineName: "Atlantic Airways",
  },
  {
    AirlineCode: "RD",
    AirlineName: "Ryan International Airlines",
  },
  {
    AirlineCode: "RE",
    AirlineName: "Stobart Air",
  },
  {
    AirlineCode: "RF",
    AirlineName: "Florida West International Airways",
  },
  {
    AirlineCode: "RG",
    AirlineName: "VRG Linhas Aéreas",
  },
  {
    AirlineCode: "RH",
    AirlineName: "Republic Express Airlines",
  },
  {
    AirlineCode: "RI",
    AirlineName: "Mandala Airlines",
  },
  {
    AirlineCode: "RJ",
    AirlineName: "Royal Jordanian",
  },
  {
    AirlineCode: "RK",
    AirlineName: "Royal Khmer Airlines",
  },
  {
    AirlineCode: "RL",
    AirlineName: "Royal Falcon",
  },
  {
    AirlineCode: "RM",
    AirlineName: "Air Company Armenia",
  },
  {
    AirlineCode: "RO",
    AirlineName: "Tarom",
  },
  {
    AirlineCode: "RP",
    AirlineName: "Chautauqua Airlines",
  },
  {
    AirlineCode: "RQ",
    AirlineName: "Kam Air",
  },
  {
    AirlineCode: "RR",
    AirlineName: "Royal Air Force",
  },
  {
    AirlineCode: "RS",
    AirlineName: "Air Seoul",
  },
  {
    AirlineCode: "RT",
    AirlineName: "RT",
  },
  {
    AirlineCode: "RU",
    AirlineName: "Air Bridge Cargo",
  },
  {
    AirlineCode: "RV",
    AirlineName: "Air Canada Rouge",
  },
  {
    AirlineCode: "RW",
    AirlineName: "Republic Airlines",
  },
  {
    AirlineCode: "RX",
    AirlineName: "Aviaexpress",
  },
  {
    AirlineCode: "RY",
    AirlineName: "Jiangxi Air",
  },
  {
    AirlineCode: "RZ",
    AirlineName: "Euro Exec Express",
  },
  {
    AirlineCode: "S0",
    AirlineName: "Slok Air Gambia",
  },
  {
    AirlineCode: "S2",
    AirlineName: "Jet Lite",
  },
  {
    AirlineCode: "S3",
    AirlineName: "Santa Barbara Airlines",
  },
  {
    AirlineCode: "S4",
    AirlineName: "SATA International",
  },
  {
    AirlineCode: "S5",
    AirlineName: "Small Planet",
  },
  {
    AirlineCode: "S6",
    AirlineName: "Sunrise Airways",
  },
  {
    AirlineCode: "S7",
    AirlineName: "Siberia",
  },
  {
    AirlineCode: "S8",
    AirlineName: "Sounds Air",
  },
  {
    AirlineCode: "S9",
    AirlineName: "FlyBig",
  },
  {
    AirlineCode: "SA",
    AirlineName: "South African Airways",
  },
  {
    AirlineCode: "SB",
    AirlineName: "Air Caledonie International",
  },
  {
    AirlineCode: "SBT",
    AirlineName: "Taftan Air",
  },
  {
    AirlineCode: "SC",
    AirlineName: "Shandong Airlines",
  },
  {
    AirlineCode: "SD",
    AirlineName: "Sudan Airways",
  },
  {
    AirlineCode: "SE",
    AirlineName: "XL Airways France",
  },
  {
    AirlineCode: "SF",
    AirlineName: "Tassili Airlines",
  },
  {
    AirlineCode: "SG",
    AirlineName: "Spicejet",
  },
  {
    AirlineCode: "SH",
    AirlineName: "Fly Me Sweden",
  },
  {
    AirlineCode: "SHI",
    AirlineName: "Sepehran",
  },
  {
    AirlineCode: "SI",
    AirlineName: "Blue Islands",
  },
  {
    AirlineCode: "SJ",
    AirlineName: "Sriwijaya Air",
  },
  {
    AirlineCode: "SJT",
    AirlineName: "Asa Jet Airlines",
  },
  {
    AirlineCode: "SK",
    AirlineName: "Scandinavian Airlines",
  },
  {
    AirlineCode: "SL",
    AirlineName: "Thai Lion Air",
  },
  {
    AirlineCode: "SLS",
    AirlineName: "SLS",
  },
  {
    AirlineCode: "SM",
    AirlineName: "Air Cairo",
  },
  {
    AirlineCode: "SN",
    AirlineName: "Brussels Airlines",
  },
  {
    AirlineCode: "SO",
    AirlineName: "Apex Airline",
  },
  {
    AirlineCode: "SP",
    AirlineName: "SATA Air Acores",
  },
  {
    AirlineCode: "SPN",
    AirlineName: "Sepahan Air",
  },
  {
    AirlineCode: "SQ",
    AirlineName: "Singapore Airlines",
  },
  {
    AirlineCode: "SR",
    AirlineName: "Sundair",
  },
  {
    AirlineCode: "SS",
    AirlineName: "Corsairfly",
  },
  {
    AirlineCode: "ST",
    AirlineName: "Germania",
  },
  {
    AirlineCode: "SU",
    AirlineName: "Aeroflot Airlines",
  },
  {
    AirlineCode: "SV",
    AirlineName: "Saudia",
  },
  {
    AirlineCode: "SW",
    AirlineName: "Air Namibia",
  },
  {
    AirlineCode: "SX",
    AirlineName: "Skywork Airlines",
  },
  {
    AirlineCode: "SY",
    AirlineName: "Sun Country Airlines",
  },
  {
    AirlineCode: "SZ",
    AirlineName: "Somon Air",
  },
  {
    AirlineCode: "T2",
    AirlineName: "Thai Air Cargo",
  },
  {
    AirlineCode: "T3",
    AirlineName: "Eastern Airways",
  },
  {
    AirlineCode: "T4",
    AirlineName: "TRIP Linhas Aéreas",
  },
  {
    AirlineCode: "T5",
    AirlineName: "Turkmenistan Airlines",
  },
  {
    AirlineCode: "T6",
    AirlineName: "Tavrey Airlines",
  },
  {
    AirlineCode: "T7",
    AirlineName: "Twin Jet",
  },
  {
    AirlineCode: "T9",
    AirlineName: "Aviator Aviation",
  },
  {
    AirlineCode: "TA",
    AirlineName: "Taca International Airline",
  },
  {
    AirlineCode: "TB",
    AirlineName: "Jetairfly",
  },
  {
    AirlineCode: "TBM",
    AirlineName: "TBM",
  },
  {
    AirlineCode: "TBN",
    AirlineName: "Taban",
  },
  {
    AirlineCode: "TBZ",
    AirlineName: "TBZ",
  },
  {
    AirlineCode: "TC",
    AirlineName: "Air Tanzania",
  },
  {
    AirlineCode: "TD",
    AirlineName: "Atlantis European Airways",
  },
  {
    AirlineCode: "TE",
    AirlineName: "Sky Taxi",
  },
  {
    AirlineCode: "TF",
    AirlineName: "Braathens Regional Aviation ",
  },
  {
    AirlineCode: "TG",
    AirlineName: "Thai Airways International",
  },
  {
    AirlineCode: "TH",
    AirlineName: "Transmile Air Services",
  },
  {
    AirlineCode: "TI",
    AirlineName: "Tailwind Airlines",
  },
  {
    AirlineCode: "TJ",
    AirlineName: "Tradewind Aviation",
  },
  {
    AirlineCode: "TK",
    AirlineName: "Turkish Airlines",
  },
  {
    AirlineCode: "TL",
    AirlineName: "Airnorth",
  },
  {
    AirlineCode: "TM",
    AirlineName: "Linhas Aéreas de Moçambique",
  },
  {
    AirlineCode: "TN",
    AirlineName: "Air Tahiti Nui",
  },
  {
    AirlineCode: "TO",
    AirlineName: "Transavia France",
  },
  {
    AirlineCode: "TP",
    AirlineName: "TAP Portugal",
  },
  {
    AirlineCode: "TQ",
    AirlineName: "Tandem Aero",
  },
  {
    AirlineCode: "TR",
    AirlineName: "Scoot/TigerAir Singapore",
  },
  {
    AirlineCode: "TS",
    AirlineName: "Air Transat",
  },
  {
    AirlineCode: "TT",
    AirlineName: "Tiger Airways Australia",
  },
  {
    AirlineCode: "TU",
    AirlineName: "Tunisair",
  },
  {
    AirlineCode: "TUL",
    AirlineName: "Tulpar Air",
  },
  {
    AirlineCode: "TV",
    AirlineName: "Virgin Express",
  },
  {
    AirlineCode: "TW",
    AirlineName: "TWAY AIR",
  },
  {
    AirlineCode: "TWI",
    AirlineName: "TWI",
  },
  {
    AirlineCode: "TX",
    AirlineName: "Air Caraibes",
  },
  {
    AirlineCode: "TY",
    AirlineName: "Air Caledonie",
  },
  {
    AirlineCode: "TZ",
    AirlineName: "Scoot",
  },
  {
    AirlineCode: "U2",
    AirlineName: "easyJet",
  },
  {
    AirlineCode: "U3",
    AirlineName: "Avies",
  },
  {
    AirlineCode: "U4",
    AirlineName: "PMTair",
  },
  {
    AirlineCode: "U5",
    AirlineName: "USA3000 Airlines",
  },
  {
    AirlineCode: "U6",
    AirlineName: "Ural Airlines",
  },
  {
    AirlineCode: "U7",
    AirlineName: "Air Uganda",
  },
  {
    AirlineCode: "U8",
    AirlineName: "Armavia",
  },
  {
    AirlineCode: "UA",
    AirlineName: "United Airlines",
  },
  {
    AirlineCode: "UB",
    AirlineName: "Myanmar National Airlines",
  },
  {
    AirlineCode: "UBD",
    AirlineName: "UBD",
  },
  {
    AirlineCode: "UD",
    AirlineName: "Hex'Air",
  },
  {
    AirlineCode: "UE",
    AirlineName: "Ultimate Jetcharters",
  },
  {
    AirlineCode: "UF",
    AirlineName: "UM Airlines",
  },
  {
    AirlineCode: "UG",
    AirlineName: "Tunisair Express",
  },
  {
    AirlineCode: "UH",
    AirlineName: "Atlasjet Ukraine",
  },
  {
    AirlineCode: "UI",
    AirlineName: "Super Air Jet",
  },
  {
    AirlineCode: "UJ",
    AirlineName: "Almasria Universal Airlines",
  },
  {
    AirlineCode: "UK",
    AirlineName: "Vistara",
  },
  {
    AirlineCode: "UL",
    AirlineName: "SriLankan Airlines",
  },
  {
    AirlineCode: "UM",
    AirlineName: "Air Zimbabwe",
  },
  {
    AirlineCode: "UN",
    AirlineName: "Transaero Airlines",
  },
  {
    AirlineCode: "UO",
    AirlineName: "Hong Kong Express Airways",
  },
  {
    AirlineCode: "UP",
    AirlineName: "Bahamasair",
  },
  {
    AirlineCode: "UQ",
    AirlineName: "O'Connor Airlines",
  },
  {
    AirlineCode: "UR",
    AirlineName: "UR",
  },
  {
    AirlineCode: "US",
    AirlineName: "US Airways",
  },
  {
    AirlineCode: "UT",
    AirlineName: "UTair Aviation",
  },
  {
    AirlineCode: "UU",
    AirlineName: "Air Austral",
  },
  {
    AirlineCode: "UW",
    AirlineName: "Perimeter Airlines",
  },
  {
    AirlineCode: "UX",
    AirlineName: "Air Europa",
  },
  {
    AirlineCode: "UY",
    AirlineName: "Cameroon Airlines",
  },
  {
    AirlineCode: "UZ",
    AirlineName: "El-Buraq Air Transport",
  },
  {
    AirlineCode: "V0",
    AirlineName: "Conviasa",
  },
  {
    AirlineCode: "V2",
    AirlineName: "Vision Airlines",
  },
  {
    AirlineCode: "V3",
    AirlineName: "Carpatair",
  },
  {
    AirlineCode: "V4",
    AirlineName: "Reem Air",
  },
  {
    AirlineCode: "V5",
    AirlineName: "Aerovias DAP",
  },
  {
    AirlineCode: "V6",
    AirlineName: "V6",
  },
  {
    AirlineCode: "V7",
    AirlineName: "Volotea",
  },
  {
    AirlineCode: "V8",
    AirlineName: "Iliamna Air",
  },
  {
    AirlineCode: "V9",
    AirlineName: "Van Air Europe",
  },
  {
    AirlineCode: "VA",
    AirlineName: "Virgin Australia",
  },
  {
    AirlineCode: "VB",
    AirlineName: "Aeroenlaces Nacionales",
  },
  {
    AirlineCode: "VC",
    AirlineName: "Via Airlines",
  },
  {
    AirlineCode: "VD",
    AirlineName: "Hennan Airlines",
  },
  {
    AirlineCode: "VE",
    AirlineName: "C.A.I. Second",
  },
  {
    AirlineCode: "VF",
    AirlineName: "Valuair",
  },
  {
    AirlineCode: "VG",
    AirlineName: "VLM Airlines",
  },
  {
    AirlineCode: "VH",
    AirlineName: "Viva Colombia",
  },
  {
    AirlineCode: "VI",
    AirlineName: "Volga-Dnepr Airlines",
  },
  {
    AirlineCode: "VJ",
    AirlineName: "Vietjet Aviation",
  },
  {
    AirlineCode: "VK",
    AirlineName: "Anisec Luftfahrt",
  },
  {
    AirlineCode: "VL",
    AirlineName: "Air VIA",
  },
  {
    AirlineCode: "VM",
    AirlineName: "Max Air Limited",
  },
  {
    AirlineCode: "VN",
    AirlineName: "Vietnam Airlines",
  },
  {
    AirlineCode: "VO",
    AirlineName: "Tyrolean Airways",
  },
  {
    AirlineCode: "VP",
    AirlineName: "VASP",
  },
  {
    AirlineCode: "VQ",
    AirlineName: "Novoair",
  },
  {
    AirlineCode: "VR",
    AirlineName: "Transportes Aereos de Cabo Verde",
  },
  {
    AirlineCode: "VRH",
    AirlineName: "Varesh",
  },
  {
    AirlineCode: "VS",
    AirlineName: "Virgin Atlantic Airways",
  },
  {
    AirlineCode: "VT",
    AirlineName: "Air Tahiti",
  },
  {
    AirlineCode: "VU",
    AirlineName: "Air Ivoire",
  },
  {
    AirlineCode: "VV",
    AirlineName: "Aerosvit Airlines",
  },
  {
    AirlineCode: "VW",
    AirlineName: "Aeromar",
  },
  {
    AirlineCode: "VX",
    AirlineName: "Virgin America",
  },
  {
    AirlineCode: "VY",
    AirlineName: "Vueling Airlines",
  },
  {
    AirlineCode: "VZ",
    AirlineName: "Thai Vietjat Air",
  },
  {
    AirlineCode: "W1",
    AirlineName: "WDL Aviation",
  },
  {
    AirlineCode: "W2",
    AirlineName: "World2Fly",
  },
  {
    AirlineCode: "W3",
    AirlineName: "Arik Air",
  },
  {
    AirlineCode: "W4",
    AirlineName: "Aero Services Executive",
  },
  {
    AirlineCode: "W5",
    AirlineName: "Mahan Air",
  },
  {
    AirlineCode: "W6",
    AirlineName: "Wizz Air",
  },
  {
    AirlineCode: "W7",
    AirlineName: "Sayakhat Airlines",
  },
  {
    AirlineCode: "W8",
    AirlineName: "Cargojet Airways",
  },
  {
    AirlineCode: "W9",
    AirlineName: "Wizz Air UK",
  },
  {
    AirlineCode: "WA",
    AirlineName: "KLM Cityhopper",
  },
  {
    AirlineCode: "WB",
    AirlineName: "Rwandair Express",
  },
  {
    AirlineCode: "WC",
    AirlineName: "Islena De Inversiones",
  },
  {
    AirlineCode: "WD",
    AirlineName: "Amsterdam Airlines",
  },
  {
    AirlineCode: "WE",
    AirlineName: "Thai Smile Airways",
  },
  {
    AirlineCode: "WF",
    AirlineName: "Widerøe",
  },
  {
    AirlineCode: "WG",
    AirlineName: "Sunwing Airlines",
  },
  {
    AirlineCode: "WH",
    AirlineName: "West African Airlines",
  },
  {
    AirlineCode: "WI",
    AirlineName: "White Airways S.A.",
  },
  {
    AirlineCode: "WJ",
    AirlineName: "Labrador Airways",
  },
  {
    AirlineCode: "WK",
    AirlineName: "Edelweiss Air",
  },
  {
    AirlineCode: "WM",
    AirlineName: "Windward Island Airways",
  },
  {
    AirlineCode: "WN",
    AirlineName: "Southwest Airlines",
  },
  {
    AirlineCode: "WO",
    AirlineName: "Swoop Inc",
  },
  {
    AirlineCode: "WP",
    AirlineName: "Island Air",
  },
  {
    AirlineCode: "WQ",
    AirlineName: "WQ",
  },
  {
    AirlineCode: "WR",
    AirlineName: "WestJet Encore",
  },
  {
    AirlineCode: "WS",
    AirlineName: "WestJet",
  },
  {
    AirlineCode: "WT",
    AirlineName: "Uep Fly",
  },
  {
    AirlineCode: "WU",
    AirlineName: "WU",
  },
  {
    AirlineCode: "WV",
    AirlineName: "Swe Fly",
  },
  {
    AirlineCode: "WV2",
    AirlineName: "WV2",
  },
  {
    AirlineCode: "WW",
    AirlineName: "WOW Air",
  },
  {
    AirlineCode: "WX",
    AirlineName: "CityJet",
  },
  {
    AirlineCode: "WY",
    AirlineName: "Oman Air",
  },
  {
    AirlineCode: "WZ",
    AirlineName: "Red Wings Airline",
  },
  {
    AirlineCode: "X1",
    AirlineName: "X1",
  },
  {
    AirlineCode: "X3",
    AirlineName: "Hapag-Lloyd Express (TUIfly)",
  },
  {
    AirlineCode: "X4",
    AirlineName: "X4",
  },
  {
    AirlineCode: "X5",
    AirlineName: "X5",
  },
  {
    AirlineCode: "X7",
    AirlineName: "Chitaavia",
  },
  {
    AirlineCode: "X8",
    AirlineName: "X8",
  },
  {
    AirlineCode: "X9",
    AirlineName: "Avion Express",
  },
  {
    AirlineCode: "XC",
    AirlineName: "Corendon Airlines",
  },
  {
    AirlineCode: "XE",
    AirlineName: "JetSuite Air",
  },
  {
    AirlineCode: "XF",
    AirlineName: "Vladivostok Air",
  },
  {
    AirlineCode: "XG",
    AirlineName: "Sunexpress Germany",
  },
  {
    AirlineCode: "XH",
    AirlineName: "XH",
  },
  {
    AirlineCode: "XJ",
    AirlineName: "Thai AirAsia",
  },
  {
    AirlineCode: "XK",
    AirlineName: "Corse Méditerranée",
  },
  {
    AirlineCode: "XL",
    AirlineName: "Latam Airlines Ecuador",
  },
  {
    AirlineCode: "XM",
    AirlineName: "J-Air",
  },
  {
    AirlineCode: "XO",
    AirlineName: "Seair",
  },
  {
    AirlineCode: "XP",
    AirlineName: "Avelo Airlines",
  },
  {
    AirlineCode: "XQ",
    AirlineName: "SunExpress",
  },
  {
    AirlineCode: "XR",
    AirlineName: "Corendon Airlines Europe",
  },
  {
    AirlineCode: "XS",
    AirlineName: "SITA",
  },
  {
    AirlineCode: "XT",
    AirlineName: "PT Indonesia Airasia Extra",
  },
  {
    AirlineCode: "XW",
    AirlineName: "Nokscoot Airlines",
  },
  {
    AirlineCode: "XX",
    AirlineName: "XX",
  },
  {
    AirlineCode: "XY",
    AirlineName: "Flynas",
  },
  {
    AirlineCode: "XZ",
    AirlineName: "Aeroitalia",
  },
  {
    AirlineCode: "Y0",
    AirlineName: "Yellow Air Taxi/Friendship Airways",
  },
  {
    AirlineCode: "Y2",
    AirlineName: "Ygnus Air",
  },
  {
    AirlineCode: "Y4",
    AirlineName: "Volaris",
  },
  {
    AirlineCode: "Y5",
    AirlineName: "Golden Myanmar Airlines",
  },
  {
    AirlineCode: "Y6",
    AirlineName: "Batavia Air",
  },
  {
    AirlineCode: "Y7",
    AirlineName: "JSC Airline",
  },
  {
    AirlineCode: "Y8",
    AirlineName: "Yangtze River Express",
  },
  {
    AirlineCode: "Y91",
    AirlineName: "Y91",
  },
  {
    AirlineCode: "YB",
    AirlineName: "Harbour Air",
  },
  {
    AirlineCode: "YC",
    AirlineName: "Yamal Airlines",
  },
  {
    AirlineCode: "YD",
    AirlineName: "Cologne Air Transport GmbH",
  },
  {
    AirlineCode: "YE",
    AirlineName: "Yan Air",
  },
  {
    AirlineCode: "YG",
    AirlineName: "South Airlines",
  },
  {
    AirlineCode: "YH",
    AirlineName: "West Caribbean Airways",
  },
  {
    AirlineCode: "YI",
    AirlineName: "Air Sunshine",
  },
  {
    AirlineCode: "YJ",
    AirlineName: "Asian Wings Airways",
  },
  {
    AirlineCode: "YK",
    AirlineName: "AVIA TRAFFIC COMPANY",
  },
  {
    AirlineCode: "YL",
    AirlineName: "Yamal Airlines",
  },
  {
    AirlineCode: "YM",
    AirlineName: "Montenegro Airlines",
  },
  {
    AirlineCode: "YN",
    AirlineName: "Air Creebec",
  },
  {
    AirlineCode: "YO",
    AirlineName: "Heli Air Monaco",
  },
  {
    AirlineCode: "YP",
    AirlineName: "YP",
  },
  {
    AirlineCode: "YQ",
    AirlineName: "Link Conexion Aerea",
  },
  {
    AirlineCode: "YR",
    AirlineName: "Scenic Airlines",
  },
  {
    AirlineCode: "YS",
    AirlineName: "Régional Compagnie Aérienne Européenne",
  },
  {
    AirlineCode: "YT",
    AirlineName: "Yeti Airlines",
  },
  {
    AirlineCode: "YU",
    AirlineName: "EuroAtlantic Airways",
  },
  {
    AirlineCode: "YV",
    AirlineName: "Mesa Airlines",
  },
  {
    AirlineCode: "YW",
    AirlineName: "Air Nostrum",
  },
  {
    AirlineCode: "YX",
    AirlineName: "Midwest Airlines",
  },
  {
    AirlineCode: "YY",
    AirlineName: "YY",
  },
  {
    AirlineCode: "YZ",
    AirlineName: "Alas Uruguay",
  },
  {
    AirlineCode: "Z0",
    AirlineName: "Z0",
  },
  {
    AirlineCode: "Z2",
    AirlineName: "Airasia Zest",
  },
  {
    AirlineCode: "Z3",
    AirlineName: "Avient Aviation",
  },
  {
    AirlineCode: "Z4",
    AirlineName: "Zagros Jet",
  },
  {
    AirlineCode: "Z5",
    AirlineName: "GMG Airlines",
  },
  {
    AirlineCode: "Z6",
    AirlineName: "Dniproavia",
  },
  {
    AirlineCode: "Z7",
    AirlineName: "ADC Airlines",
  },
  {
    AirlineCode: "Z8",
    AirlineName: "Línea Aérea Amaszonas",
  },
  {
    AirlineCode: "Z9",
    AirlineName: "MYAirline",
  },
  {
    AirlineCode: "ZA",
    AirlineName: "Sky Angkor Airlines",
  },
  {
    AirlineCode: "ZB",
    AirlineName: "Air Albania",
  },
  {
    AirlineCode: "ZD",
    AirlineName: "ZD",
  },
  {
    AirlineCode: "ZE",
    AirlineName: "Eastar Jet",
  },
  {
    AirlineCode: "ZF",
    AirlineName: "Azur Air",
  },
  {
    AirlineCode: "ZG",
    AirlineName: "ZIPAIR ",
  },
  {
    AirlineCode: "ZH",
    AirlineName: "Shenzhen Airlines",
  },
  {
    AirlineCode: "ZI",
    AirlineName: "Aigle Azur",
  },
  {
    AirlineCode: "ZK",
    AirlineName: "Great Lakes Airlines",
  },
  {
    AirlineCode: "ZL",
    AirlineName: "Regional Express",
  },
  {
    AirlineCode: "ZM",
    AirlineName: "Pegasus Asia",
  },
  {
    AirlineCode: "ZN",
    AirlineName: "ZN",
  },
  {
    AirlineCode: "ZO",
    AirlineName: "Zagros Airline",
  },
  {
    AirlineCode: "ZP",
    AirlineName: "Silk Way Airlines",
  },
  {
    AirlineCode: "ZQ",
    AirlineName: "ZQ",
  },
  {
    AirlineCode: "ZS",
    AirlineName: "Kazaviaspas",
  },
  {
    AirlineCode: "ZT",
    AirlineName: "Titan Airways",
  },
  {
    AirlineCode: "ZU",
    AirlineName: "Helios Airways",
  },
  {
    AirlineCode: "ZV",
    AirlineName: "Zagros",
  },
  {
    AirlineCode: "ZW",
    AirlineName: "Air Wisconsin",
  },
  {
    AirlineCode: "ZX",
    AirlineName: "Air Georgian",
  },
  {
    AirlineCode: "ZY",
    AirlineName: "Sky Airlines",
  },
  {
    AirlineCode: "ZZ",
    AirlineName: "AeroCRS",
  },
];
